import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { Component, EventEmitter, HostListener, Input, OnInit, Output, computed, signal } from '@angular/core';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// @ts-ignore
import { forkJoin, firstValueFrom, of } from 'rxjs';
import { ProdutoService, CAMPOS_DUPLICACAO, CAMPO_LABELS } from '../../services/produto.service';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { EstoqueService } from '../../services/estoque.service';
import { ProdutoBusca } from '../../models/estoque.model';
import { CampoDuplicacao, OpcaoCampo, OpcaoCopia, ResultadoCopiaTabela } from '../../models/produto.model';
import { removerLinhasCotacao } from '../../shared/observacao-cotacao.util';

type Etapa = 'lista' | 'form' | 'preco' | 'sucesso';

// @ts-ignore
@Component({
  selector: 'app-duplicar-produto',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
  templateUrl: './duplicar-produto.component.html',
  styleUrl: './duplicar-produto.component.css'
})
export class DuplicarProdutoComponent implements OnInit {
  /** Emitido quando o usuário clica no card "Produto Cadastrado com Sucesso!",
   * pedindo pro Gateway navegar direto pra tela de Edição de Produtos já
   * aberta nesse produto (evita precisar buscar de novo manualmente). */
  @Output() irParaEdicao = new EventEmitter<string>();
  @Input() pnAutoPreencher: string | null = null;
  @Output() pnAutoPreencherConsumido = new EventEmitter<void>();
  /** Produto vindo do botão "Clonar" da Edição: abre direto o formulário usando-o como modelo. */
  @Input() produtoClonar: { codprod: string; partNumber: string; nome: string; imagem?: string } | null = null;
  @Output() produtoClonarConsumido = new EventEmitter<void>();
  /** Tela de onde veio o Clonar (lista/edição); null = clonado aqui mesmo, no Cadastro. */
  @Input() origemClone: 'lista-produtos' | 'gpl-edicaodeprodutos' | null = null;
  @Output() voltarOrigem = new EventEmitter<{ origem: 'lista-produtos' | 'gpl-edicaodeprodutos'; codprod: string }>();
  /** 'lista-produtos' quando o Cadastrar foi aberto pelo botao da Lista de Produtos (novo produto, nao clone). */
  @Input() origemCadastro: 'lista-produtos' | null = null;
  /** Aberto a partir da Lista (novo ou clone): depois de salvar volta pra ela. */
  private retornoLista = false;
  private retornarAposAlerta = false;
  /** Origem e produto-fonte do clone atual (guardados ao abrir). */
  origemRetorno: 'lista-produtos' | 'gpl-edicaodeprodutos' | null = null;
  private codprodFonteClone = '';

  loading = signal(false);
  loadingMsg = signal('');

  etapa = signal<Etapa>('lista');

  // Aviso "campos pré-preenchidos" no topo da etapa 2 -- só informativo,
  // então some sozinho depois de alguns segundos em vez de ficar fixo
  // ocupando espaço. Reaparece toda vez que a etapa 2 é (re)aberta -- ver
  // _exibirAvisoInfoTemporario(), chamado nos dois pontos que fazem
  // etapa.set('form').
  avisoInfoVisivel = signal(true);
  private _avisoInfoTimeout: any = null;

  private _exibirAvisoInfoTemporario(): void {
    this.avisoInfoVisivel.set(true);
    if (this._avisoInfoTimeout) clearTimeout(this._avisoInfoTimeout);
    this._avisoInfoTimeout = setTimeout(() => this.avisoInfoVisivel.set(false), 6000);
  }

  // Aviso "Preço não informado" também é temporário (some sozinho após alguns
  // segundos), igual ao aviso-info acima.
  avisoSemPrecoVisivel = signal(false);
  private _avisoSemPrecoTimeout: any = null;

  private _exibirAvisoSemPrecoTemporario(): void {
    this.avisoSemPrecoVisivel.set(true);
    if (this._avisoSemPrecoTimeout) clearTimeout(this._avisoSemPrecoTimeout);
    this._avisoSemPrecoTimeout = setTimeout(() => this.avisoSemPrecoVisivel.set(false), 6000);
  }

  /** Blur do Preço Fabricante: recalcula e, se ficou zerado, avisa por alguns segundos. */
  onBlurPrecoFabricante(): void {
    this.calcularPreco();
    if (this.precoToNumber(this.precoForm.precoFabricante) === 0) {
      this._exibirAvisoSemPrecoTemporario();
    } else {
      this.avisoSemPrecoVisivel.set(false);
    }
  }

  // Unidades de medida com nome/sigla em inglês (ver buscarUnidadesMedidaIngles).
  unidadesIngles = signal<{ codvol: string; nomeIngles: string; siglaIngles: string }[]>([]);

  /** Unidade em inglês da CODVOL atualmente selecionada (acompanha a troca da unidade). */
  unidadeInglesAtual(): { nomeIngles: string; siglaIngles: string } | null {
    const cod = (this.campos().find((c) => c.field === 'CODVOL')?.valor ?? '').toString().trim().toUpperCase();
    if (!cod) return null;
    return this.unidadesIngles().find((u) => (u.codvol ?? '').trim().toUpperCase() === cod) ?? null;
  }

  termoBusca = 'MODELO - ';
  modelos = signal<ProdutoBusca[]>([]);
  buscando = signal(false);

  // Limita a lista de produtos modelo exibida inicialmente, com botão
  // "Ver mais" para exibir o restante quando houver.
  private readonly LIMITE_INICIAL_MODELOS = 10;
  limiteModelos = signal(this.LIMITE_INICIAL_MODELOS);

  modelosExibidos = computed(() => this.modelos().slice(0, this.limiteModelos()));

  produtoOrigem: ProdutoBusca | null = null;
  campos = signal<CampoDuplicacao[]>([]);
  /** Campos de imposto (TGFPRO) lidos do produto modelo via SELECT *. Incluídos no INSERT inicial. */
  private impostosDoModelo: Record<string, string> = {};

  novoCodProd = signal<string | null>(null);

  alertaModal = signal(false);
  alertaTexto = signal('');
  alertaTipo = signal<'sucesso' | 'erro' | 'aviso'>('aviso');

  // Busca de Marca (modal "Procurando por Marca", igual ao Sankhya)
  marcas = signal<OpcaoCampo[]>([]);
  marcaModalAberta = signal(false);
  filtroMarca = signal('');

  marcasFiltradas = computed(() => {
    const filtro = this.filtroMarca().trim().toUpperCase();
    const lista = this.marcas();
    if (!filtro) {
      return lista;
    }
    return lista.filter((m) => m.label.toUpperCase().includes(filtro));
  });

  // Busca de Grupo de Produto (modal "Procurando por Grupo de Produto")
  grupos = signal<OpcaoCampo[]>([]);
  grupoModalAberta = signal(false);
  filtroGrupo = signal('');

  gruposFiltrados = computed(() => {
    const filtro = this.filtroGrupo().trim().toUpperCase();
    const lista = this.grupos();
    if (!filtro) {
      return lista;
    }
    return lista.filter((g) => g.label.toUpperCase().includes(filtro));
  });

  // Busca de Local de Estoque (modal "Procurando por Local")
  locais = signal<OpcaoCampo[]>([]);
  localModalAberta = signal(false);
  filtroLocal = signal('');

  locaisFiltrados = computed(() => {
    const filtro = this.filtroLocal().trim().toUpperCase();
    const lista = this.locais();
    if (!filtro) return lista;
    return lista.filter((l) => l.label.toUpperCase().includes(filtro));
  });

  // Busca de NCM (modal "Procurando por NCM")
  ncms = signal<OpcaoCampo[]>([]);
  ncmModalAberta = signal(false);
  filtroNcm = signal('');

  ncmsFiltrados = computed(() => {
    const filtro = this.filtroNcm().trim().toUpperCase();
    if (!filtro) return [];  // NCM tem muitos itens — exige ao menos um filtro
    return this.ncms().filter((n) => n.label.toUpperCase().includes(filtro));
  });

  // "Copiar Também" — modal pré-save com opções de tabelas relacionadas
  copiaTambemModalAberta = signal(false);
  opcoesCopia = signal<OpcaoCopia[]>([
    { chave: 'impostosEmpresa', label: 'Impostos / Informações por empresa', selecionada: false },
    { chave: 'unidadesAlt',     label: 'Unidades Alternativas',              selecionada: false },
    { chave: 'produtosAlt',     label: 'Produtos Alternativos',              selecionada: false },
    { chave: 'produtosEq',      label: 'Produtos Equivalentes',              selecionada: false },
    // 'produtosSug' removido: tabela de Sugeridos para Venda não existe nesta instalação do Sankhya
  ]);
  resultadosCopia = signal<ResultadoCopiaTabela[]>([]);
  resultadosCopiaModalAberta = signal(false);

  /** Dados do produto a gravar, aguardando confirmação do "Copiar Também" */
  private _dadosPendentesParaSalvar: Record<string, string> | null = null;

  // ── Etapa de precificação ──
  precoForm = {
    precoFabricante: '0.00',
    percentualCusto: '0.00',
    totalCusto: '0.00',
    percentualLucro: '0.00',
    precoVenda: '0.00',
    valorCore: '0.00',
    fornecedor: '',
  };
  listaFornecedoresPreco: { descricao: string; cnpj?: string }[] = [];
  fornecedorDropdownAberto = false;
  private fornecedorBuscaSeq = 0;

  private debounceTimer: any = null;

  // Tradução automática PT -> EN (Descrição -> Label (USA) / DESCRESTRAG).
  // Fica "true" assim que o usuário edita o Label (USA) manualmente, para
  // não sobrescrever o que ele digitou.
  private descrEstragEditadoManualmente = false;
  private traducaoTimer: any = null;
  private descricaoEditadaManualmente = false;
  private traducaoEnPtTimer: any = null;

  // Último valor "sincronizado" (carregado do produto modelo originalmente,
  // ou preenchido automaticamente pela última atualização via Marca) de
  // "Margem de Custo" / "Margem de Lucro". Se o valor atual do campo ainda
  // for igual a este, consideramos que o usuário NÃO digitou nada manualmente
  // e o campo pode ser atualizado a partir da Marca (TGFMAR.AD_CUSTO/AD_LUCRO).
  // Se forem diferentes, o usuário alterou o campo manualmente e ele não é
  // sobrescrito. Verificação feita de forma independente para cada campo.
  // Campos vazios/zerados também são atualizados automaticamente.
  private ultimoValorSincronizadoMargemCusto = '';
  private ultimoValorSincronizadoMargemLucro = '';

  /** Descrição do Local Padrão atual (fallback enquanto a lista não carrega). */
  private _descricaoLocalAtual = '';
  /** Descrição do NCM atual (fallback enquanto a lista não carrega). */
  private _descricaoNcmAtual = '';

  // ── Gestão de imagens do novo produto ───────────────────────────────────
  imagemPrincipal: { src: string; imgId: number } | null = null;
  listaMiniaturas: { src: string; imgId: number }[] = [];
  listaImagens: { src: string; imgId: number }[] = [];
  imagemAtual: { src: string; imgId: number } | null = null;
  indexImagem = 0;
  modalGaleria = false;
  // Imagens pendentes (selecionadas no formulário, antes de salvar no banco)
  imagensPendentes: { src: string; base64: string }[] = [];
  indexPadrao = -1;
  indexVisualizandoPendente = 0;
  mostrarModalSelecao = false;
  // ────────────────────────────────────────────────────────────────────────
  // ── Importação CSV — 3 tabelas (IMP_BASE / IMP_FORMS / IMP_SERIAIS) ─────
  importacaoModalAberta = signal(false);
  importAba: 'base' | 'forms' | 'seriais' | 'nota' = 'base';

  // IMP_BASE
  csvBaseHeaders: string[] = [];
  csvBaseData:    string[][] = [];
  csvBaseNome         = signal('');
  csvBaseImportado    = signal(0);
  csvBaseImportando   = signal(false);
  mapBase = { sequencia: '', apeId: '', empId: '', estLocal: '', estQtde: '', estCusto: '', valorDeVenda: '' };

  // IMP_FORMS
  csvFormsHeaders: string[] = [];
  csvFormsData:    string[][] = [];
  csvFormsNome        = signal('');
  csvFormsImportado   = signal(0);
  csvFormsImportando  = signal(false);
  mapForms = { apeId: '', empId: '', formNumero: '', formLote: '', formDataVal: '', saldoForm: '' };

  // IMP_SERIAIS
  csvSeraisHeaders: string[] = [];
  csvSeraisData:    string[][] = [];
  csvSeraisNome       = signal('');
  csvSeraisImportado  = signal(0);
  csvSeraisImportando = signal(false);
  mapSeriais = { apeId: '', empId: '', icsNs: '' };

  // Preview / Execução
  previewItens:      any[] = [];
  previewFormsCount  = 0;
  previewSeraisCount = 0;
  previewCarregando  = signal(false);
  /** Itens de IMP_BASE cujo APE_ID não bate com nenhum CODPROD no Sankhya
   *  (TGFPRO) — somem silenciosamente do preview (INNER JOIN), diferente do
   *  Local (que cai no Coringa). Agrupado por empresa: {codemp, qtd}[]. */
  previewProdutosNaoEncontrados: { codemp: number; qtd: number }[] = [];

  // Empresas para geração da nota (Aerosys → Sankhya)
  empresas = [
    { codemp: 1, label: 'Emp 1', detalhe: 'Aerosys 1,4,7,9,11,17  ·  locais: Curitiba / BH / RV', codparc: 1, ativo: true },
    { codemp: 3, label: 'Emp 3', detalhe: 'Aerosys 5', codparc: 1, ativo: true },
    { codemp: 4, label: 'Emp 4', detalhe: 'Aerosys 8', codparc: 1, ativo: true },
    { codemp: 5, label: 'Emp 5', detalhe: 'Aerosys 13', codparc: 1, ativo: true },
    { codemp: 6, label: 'Emp 6', detalhe: 'Aerosys 3,14,6  ·  locais: Escolinha / Peças OS / Turbo', codparc: 1, ativo: true },
    { codemp: 7, label: 'Emp 7', detalhe: 'Aerosys 15', codparc: 1, ativo: true },
  ];

  execParams = {
    tipneg:     '1',
    codnat:     '3010101',
    codtipoper: '1499',
    codcencus:  '201000',
    codprojeto: '10000000',
    codtab:     '14',
  };
  execCarregando  = signal(false);
  execResultado:  { empresa: number; nunota: string }[] = [];
  execErro        = signal('');
  execMensagem    = signal('');
  execProgresso   = signal(0);
  execEmpresaAtual = signal('');
  execItensNaoImportados: { codemp: number; codprod: number; descrprod: string | null; motivo: string }[] = [];
  // ─────────────────────────────────────────────────────────────────────────

  // ── Produtos Alternativos (cadastro) ────────────────────────────────────
  modalProdutosAlternativosAberto = false;
  produtosAlternativosSelecionados: any[] = [];
  produtosAlternativosBusca: any[] = [];
  carregandoProdutosAlternativos = false;
  filtroProdutoAlternativo = '';
  /** Para quem o modal "Procurando por Marca" esta aberto: o campo Marca do produto ou o filtro do modal de alternativos. */
  marcaModalDestino: 'produto' | 'alternativo' = 'produto';
  marcaProdutoAlternativo = '';
  marcaProdutoAlternativoDescricao = '';
  private buscaAlternativosTimer: any = null;
  // ─────────────────────────────────────────────────────────────────────────

  constructor(
    private readonly produtoService: ProdutoService,
    private readonly sanitizer: DomSanitizer,
    private readonly sankhyaGateway: SankhyaGatewayService,
    private readonly estoqueService: EstoqueService
  ) {}

  ngOnInit(): void {
    this.retornoLista = this.origemCadastro === 'lista-produtos' || this.origemClone === 'lista-produtos';
    this.buscarModelos();
    if (this.produtoClonar?.codprod) {
      const c = this.produtoClonar;
      this.origemRetorno = this.origemClone;
      this.codprodFonteClone = String(c.codprod);
      this.produtoClonarConsumido.emit();
      this.selecionarModelo({
        codprod: c.codprod,
        codigo: c.codprod,
        descricao: c.nome,
        nome: c.nome,
        refforn: c.partNumber,
        partNumber: c.partNumber,
        imagem: c.imagem
      } as ProdutoBusca, true);
    }
    void this.carregarCotacaoDolarDia();
  }

  /** Fabricante nacional (EMBRAER (NEIVA)): preços cadastrados direto em Reais, sem conversão pelo dólar. */
  isMarcaNacional(): boolean {
    const cod = this.campos().find((c) => c.field === 'CODMARCA')?.valor ?? '';
    const desc = (this.descricaoMarca(cod) || this.campos().find((c) => c.field === 'MARCA')?.valor || '').trim().toUpperCase();
    return desc === 'EMBRAER (NEIVA)';
  }

  /** Símbolo da moeda dos preços: R$ para fabricante nacional, U$ para os demais. */
  moedaPreco(): string {
    return this.isMarcaNacional() ? 'R$' : 'U$';
  }

  /** Cotação do dólar do dia (mesma fonte da tela de Edição) -- usada no Preço de Venda em R$. */
  cotacaoDolarDia = signal(0);

  private async carregarCotacaoDolarDia(): Promise<void> {
    try {
      const response: any = await firstValueFrom(this.sankhyaGateway.buscarCotacoesDemonstrativo());
      const body = response?.responseBody ?? response;
      const valor = this.precoToNumber(body?.cotacoes?.[0]?.valor);
      this.cotacaoDolarDia.set(body?.sucesso !== false && valor > 0 ? valor : 0);
    } catch (e) {
      console.warn('Não foi possível carregar a cotação do dólar do dia.', e);
      this.cotacaoDolarDia.set(0);
    }
  }

  /** Preço de Venda U$ x cotação do dólar do dia (vazio se a cotação estiver indisponível). */
  precoVendaEmReais(): string {
    const dolar = this.cotacaoDolarDia();
    if (dolar <= 0) return '';
    return this.precoFormatar(this.precoToNumber(this.precoForm.precoVenda) * dolar);
  }

  abrirImportacao(): void {
    this.importAba = 'base';
    this.importacaoModalAberta.set(true);
  }

  fecharImportacao(): void {
    this.importacaoModalAberta.set(false);
    this._limparImportacao();
  }

  private _limparImportacao(): void {
    this.csvBaseHeaders = [];  this.csvBaseData = [];  this.csvBaseNome.set('');  this.csvBaseImportado.set(0);
    this.csvFormsHeaders = []; this.csvFormsData = []; this.csvFormsNome.set(''); this.csvFormsImportado.set(0);
    this.csvSeraisHeaders = [];this.csvSeraisData = [];this.csvSeraisNome.set('');this.csvSeraisImportado.set(0);
    this.mapBase    = { sequencia: '', apeId: '', empId: '', estLocal: '', estQtde: '', estCusto: '', valorDeVenda: '' };
    this.mapForms   = { apeId: '', empId: '', formNumero: '', formLote: '', formDataVal: '', saldoForm: '' };
    this.mapSeriais = { apeId: '', empId: '', icsNs: '' };
    this.previewItens = [];
    this.previewFormsCount = 0;
    this.previewSeraisCount = 0;
    this.execResultado = [];
    this.execErro.set('');
    this.execMensagem.set('');
    this.execItensNaoImportados = [];
    this.execProgresso.set(0);
    this.execEmpresaAtual.set('');
    this.execParams = { tipneg: '1', codnat: '3010101', codtipoper: '1499', codcencus: '201000', codprojeto: '10000000', codtab: '14' };
    this.empresas.forEach(e => { e.ativo = true; e.codparc = 1; });
  }

  private _parseCsv(text: string): { headers: string[]; data: string[][] } {
    const lines = text.split(/\r?\n/).filter(l => l.trim() !== '');
    if (!lines.length) return { headers: [], data: [] };
    const sep = lines[0].includes(';') ? ';' : ',';
    const strip = (s: string) => s.trim().replace(/^["']|["']$/g, '');
    const headers = lines[0].split(sep).map(strip);
    const data    = lines.slice(1).map(line => line.split(sep).map(strip));
    return { headers, data };
  }

  // ── IMP_BASE ──────────────────────────────────────────────────────────────
  onFileChangeCsvBase(event: any): void {
    const file = event.target.files?.[0];
    if (!file) return;
    this.csvBaseNome.set(file.name);
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const { headers, data } = this._parseCsv(e.target.result);
      this.csvBaseHeaders = headers;
      this.csvBaseData    = data;
      this._autoMapBase();
    };
    reader.readAsText(file, 'utf-8');
  }

  private _autoMapBase(): void {
    this.mapBase = { sequencia: '', apeId: '', empId: '', estLocal: '', estQtde: '', estCusto: '', valorDeVenda: '' };
    for (const h of this.csvBaseHeaders) {
      const l = h.toLowerCase();
      if (l === 'sequencia')          this.mapBase.sequencia    = h;
      else if (l === 'ape_id')        this.mapBase.apeId        = h;
      else if (l === 'emp_id')        this.mapBase.empId        = h;
      else if (l === 'est_local')     this.mapBase.estLocal     = h;
      else if (l === 'est_qtde')      this.mapBase.estQtde      = h;
      else if (l === 'est_custo')     this.mapBase.estCusto     = h;
      else if (l === 'valor_de_venda') this.mapBase.valorDeVenda = h;
    }
  }

  async importarBase(): Promise<void> {
    if (!this.csvBaseHeaders.length) { this.abrirAlerta('Selecione um arquivo CSV para IMP_BASE.', 'aviso'); return; }
    const payload = this._buildPayload(this.csvBaseHeaders, this.csvBaseData, this.mapBase as any);
    if (!payload.length) { this.abrirAlerta('CSV sem dados válidos.', 'aviso'); return; }
    this.csvBaseImportando.set(true);
    const ok = await this._importarLotes(payload, (lote) => this.estoqueService.importarBase(lote), 'IMP_BASE');
    this.csvBaseImportando.set(false);
    if (ok) this.csvBaseImportado.set(payload.length);
  }

  // ── IMP_FORMS ─────────────────────────────────────────────────────────────
  onFileChangeCsvForms(event: any): void {
    const file = event.target.files?.[0];
    if (!file) return;
    this.csvFormsNome.set(file.name);
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const { headers, data } = this._parseCsv(e.target.result);
      this.csvFormsHeaders = headers;
      this.csvFormsData    = data;
      this._autoMapForms();
    };
    reader.readAsText(file, 'utf-8');
  }

  private _autoMapForms(): void {
    this.mapForms = { apeId: '', empId: '', formNumero: '', formLote: '', formDataVal: '', saldoForm: '' };
    for (const h of this.csvFormsHeaders) {
      const l = h.toLowerCase();
      if (l === 'ape_id')               this.mapForms.apeId      = h;
      else if (l === 'emp_id')          this.mapForms.empId      = h;
      else if (l === 'ico_form_numero') this.mapForms.formNumero = h;
      else if (l === 'ico_form_lote')   this.mapForms.formLote   = h;
      else if (l === 'ico_form_data_val') this.mapForms.formDataVal = h;
      else if (l === 'saldo_form')      this.mapForms.saldoForm  = h;
    }
  }

  async importarForms(): Promise<void> {
    if (!this.csvFormsHeaders.length) { this.abrirAlerta('Selecione um arquivo CSV para IMP_FORMS.', 'aviso'); return; }
    const payload = this._buildPayload(this.csvFormsHeaders, this.csvFormsData, this.mapForms as any);
    if (!payload.length) { this.abrirAlerta('CSV sem dados válidos.', 'aviso'); return; }
    this.csvFormsImportando.set(true);
    const ok = await this._importarLotes(payload, (lote) => this.estoqueService.importarForms(lote), 'IMP_FORMS');
    this.csvFormsImportando.set(false);
    if (ok) this.csvFormsImportado.set(payload.length);
  }

  // ── IMP_SERIAIS ───────────────────────────────────────────────────────────
  onFileChangeCsvSeriais(event: any): void {
    const file = event.target.files?.[0];
    if (!file) return;
    this.csvSeraisNome.set(file.name);
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const { headers, data } = this._parseCsv(e.target.result);
      this.csvSeraisHeaders = headers;
      this.csvSeraisData    = data;
      this._autoMapSeriais();
    };
    reader.readAsText(file, 'utf-8');
  }

  private _autoMapSeriais(): void {
    this.mapSeriais = { apeId: '', empId: '', icsNs: '' };
    for (const h of this.csvSeraisHeaders) {
      const l = h.toLowerCase();
      if (l === 'ape_id')      this.mapSeriais.apeId = h;
      else if (l === 'emp_id') this.mapSeriais.empId = h;
      else if (l === 'ics_ns') this.mapSeriais.icsNs = h;
    }
  }

  async importarSeriais(): Promise<void> {
    if (!this.csvSeraisHeaders.length) { this.abrirAlerta('Selecione um arquivo CSV para IMP_SERIAIS.', 'aviso'); return; }
    const payload = this._buildPayload(this.csvSeraisHeaders, this.csvSeraisData, this.mapSeriais as any);
    if (!payload.length) { this.abrirAlerta('CSV sem dados válidos.', 'aviso'); return; }
    this.csvSeraisImportando.set(true);
    const ok = await this._importarLotes(payload, (lote) => this.estoqueService.importarSeriais(lote), 'IMP_SERIAIS');
    this.csvSeraisImportando.set(false);
    if (ok) this.csvSeraisImportado.set(payload.length);
  }

  // ── Helpers internos ──────────────────────────────────────────────────────
  private _buildPayload(headers: string[], data: string[][], mapping: Record<string, string>): any[] {
    const keys = Object.keys(mapping);
    return data
      .filter(row => row.some(c => c !== ''))
      .map(row => {
        const obj: any = {};
        for (const k of keys) {
          const col = mapping[k];
          obj[k] = col ? (row[headers.indexOf(col)] ?? '') : '';
        }
        return obj;
      });
  }

  private async _importarLotes(payload: any[], fn: (lote: any[]) => any, nome: string): Promise<boolean> {
    const tam = 500;
    for (let i = 0; i < payload.length; i += tam) {
      try {
        const res: any = await firstValueFrom(fn(payload.slice(i, i + tam)));
        if (res?.sucesso === false) throw new Error(res.erro || 'Erro no servidor');
      } catch (e: any) {
        this.abrirAlerta(`Erro ao importar ${nome} (lote ${Math.floor(i/tam)+1}): ${e.message}`, 'erro');
        return false;
      }
    }
    this.abrirAlerta(`${nome}: ${payload.length} registros importados!`, 'sucesso');
    return true;
  }

  // ── Preview / Execução ────────────────────────────────────────────────────
  async carregarPreview(): Promise<void> {
    this.previewCarregando.set(true);
    this.previewItens = [];
    try {
      const res: any = await firstValueFrom(this.estoqueService.previewNota());
      // O backend pode responder HTTP 200 com sucesso=false (erro de SQL/negócio
      // no addon) — sem checar isso aqui, um erro real virava silenciosamente
      // "0 itens" na tela, sem nenhum aviso do que deu errado.
      if (res?.sucesso === false || res?.sucesso === 'false') {
        this.abrirAlerta('Erro ao carregar preview: ' + (res?.erro ?? 'Erro desconhecido.'), 'erro');
      } else {
        this.previewItens      = res?.itens       || [];
        this.previewFormsCount  = res?.totalForms  || 0;
        this.previewSeraisCount = res?.totalSeriais || 0;
        this.previewProdutosNaoEncontrados = res?.produtosNaoEncontrados || [];
        if (this.previewProdutosNaoEncontrados.length > 0) {
          const totalNaoEncontrados = this.previewProdutosNaoEncontrados.reduce((s, p) => s + (p.qtd || 0), 0);
          const porEmpresa = this.previewProdutosNaoEncontrados.map(p => `Emp ${p.codemp}: ${p.qtd}`).join(', ');
          this.abrirAlerta(
            `⚠️ ${totalNaoEncontrados} item(ns) não encontrados no catálogo do Sankhya (CODPROD) e ficaram de fora do preview — ${porEmpresa}.`,
            'aviso'
          );
        }
      }
    } catch (e: any) {
      this.abrirAlerta('Erro ao carregar preview: ' + (e?.error?.erro ?? e?.message ?? 'Erro de comunicação.'), 'erro');
    }
    this.previewCarregando.set(false);
  }

  /**
   * Gera a nota em LOTES DE ITENS dentro de cada empresa (iniciar -> N lotes
   * de itens -> finalizar), em vez de mandar todos os itens de uma empresa
   * de uma vez só. Com volumes grandes (dezenas de milhares de itens), uma
   * única chamada por empresa ainda podia ser lenta demais / estourar
   * timeout; quebrando em lotes pequenos (200 itens por chamada), cada
   * requisição HTTP fica curta e o progresso mostrado é o real (item a
   * item), não uma estimativa. Se um lote falhar, a empresa segue para a
   * próxima (o que já foi inserido não é desfeito).
   */
  async executarNota(): Promise<void> {
    const empresasAtivas = this.empresas.filter(e => e.ativo);
    if (!empresasAtivas.length) {
      this.abrirAlerta('Selecione ao menos uma empresa.', 'aviso');
      return;
    }

    this.execCarregando.set(true);
    this.execErro.set('');
    this.execMensagem.set('');
    this.execResultado = [];
    this.execItensNaoImportados = [];
    this.execProgresso.set(0);

    const TAMANHO_LOTE = 50;
    // Total aproximado de itens (vindo do preview) só para calcular o % da barra.
    const totalGeral = this.previewItens.length || 1;
    let processadosGeral = 0;

    const notas: { empresa: number; nunota: string }[] = [];
    const naoImportados: any[] = [];
    const falhas: string[] = [];

    for (const emp of empresasAtivas) {
      this.execEmpresaAtual.set(`Empresa ${emp.codemp}: iniciando...`);

      let nunota: number | null = null;
      let totalItensEmpresa = 0;
      try {
        const payloadInicio = { ...this.execParams, codemp: emp.codemp, codparc: emp.codparc };
        const resInicio: any = await firstValueFrom(this.estoqueService.iniciarNotaEmpresa(payloadInicio));
        if (resInicio?.itensNaoImportados?.length) {
          naoImportados.push(...resInicio.itensNaoImportados);
        }
        if (!resInicio?.sucesso || !resInicio?.nunota) {
          falhas.push(`Empresa ${emp.codemp}: ${resInicio?.erro || 'falha ao iniciar nota'}`);
          continue;
        }
        nunota = resInicio.nunota;
        totalItensEmpresa = resInicio.totalItens || 0;
      } catch (e: any) {
        falhas.push(`Empresa ${emp.codemp}: ${e.message || 'falha de comunicação ao iniciar'}`);
        continue;
      }

      let offset = 0;
      while (offset < totalItensEmpresa) {
        this.execEmpresaAtual.set(`Empresa ${emp.codemp}: ${offset} de ${totalItensEmpresa} itens`);

        // Enquanto espera a resposta deste lote (pode levar alguns segundos por
        // causa da validação de regra de negócio do Sankhya item a item), a
        // barra "cresce" suavemente rumo à posição estimada após este lote,
        // em vez de ficar parada. Ao chegar a resposta real, corrige pro valor
        // exato — assim ela nunca fica travada olhando pro usuário.
        const progressoAntes = Math.min(99, Math.round((processadosGeral / totalGeral) * 100));
        const progressoEstimadoDepois = Math.min(
          99,
          Math.round(((processadosGeral + TAMANHO_LOTE) / totalGeral) * 100)
        );
        let subProgresso = progressoAntes;
        const nudgeTimer = setInterval(() => {
          if (subProgresso < progressoEstimadoDepois) {
            subProgresso++;
            this.execProgresso.set(subProgresso);
          }
        }, 350);

        try {
          const resLote: any = await firstValueFrom(
            this.estoqueService.processarLoteItens({ nunota, offset, tamanhoLote: TAMANHO_LOTE })
          );
          clearInterval(nudgeTimer);
          if (!resLote?.sucesso) {
            falhas.push(`Empresa ${emp.codemp}: ${resLote?.erro || 'falha ao processar lote'} (a partir do item ${offset})`);
            break;
          }
          if (resLote?.itensNaoImportados?.length) {
            naoImportados.push(...resLote.itensNaoImportados.map((it: any) => ({ ...it, codemp: emp.codemp })));
          }
          const processados = resLote.processados || 0;
          processadosGeral += processados;
          this.execProgresso.set(Math.min(99, Math.round((processadosGeral / totalGeral) * 100)));
          if (processados <= 0) break; // segurança contra loop infinito
          offset += processados;
        } catch (e: any) {
          clearInterval(nudgeTimer);
          falhas.push(`Empresa ${emp.codemp}: ${e.message || 'falha de comunicação no lote'} (a partir do item ${offset})`);
          break;
        }
      }

      this.execEmpresaAtual.set(`Empresa ${emp.codemp}: finalizando...`);
      try {
        const resFim: any = await firstValueFrom(
          this.estoqueService.finalizarNotaEmpresa({ nunota, codemp: emp.codemp, codtab: this.execParams.codtab })
        );
        if (resFim?.sucesso) {
          notas.push({ empresa: emp.codemp, nunota: String(nunota) });
        } else {
          falhas.push(`Empresa ${emp.codemp}: nota ${nunota} criada, mas falhou ao finalizar - ${resFim?.erro || 'erro desconhecido'}`);
        }
      } catch (e: any) {
        falhas.push(`Empresa ${emp.codemp}: nota ${nunota} criada, mas falhou ao finalizar - ${e.message || 'falha de comunicação'}`);
      }
    }

    this.execResultado = notas;
    this.execItensNaoImportados = naoImportados;
    this.execEmpresaAtual.set('');
    this.execProgresso.set(100);

    if (!notas.length) {
      this.execErro.set(falhas.length ? falhas.join(' | ') : 'Nenhuma nota foi gerada.');
    } else if (falhas.length) {
      this.execMensagem.set('Nota(s) gerada(s), mas com avisos: ' + falhas.join(' | '));
    }

    setTimeout(() => this.execProgresso.set(0), 700);
    this.execCarregando.set(false);
  }

  get podeAbrirNota(): boolean {
    return this.csvBaseImportado() > 0;
  }

  onTermoChange(): void {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => this.buscarModelos(), 400);
  }

  buscarModelos(): void {
    const termo = this.termoBusca.trim() || 'MODELO';
    this.buscando.set(true);
    this.limiteModelos.set(this.LIMITE_INICIAL_MODELOS);
    this.produtoService.buscarProdutosModelo(termo).subscribe({
      next: (lista) => {
        this.buscando.set(false);
        const modelosEncontrados = lista || [];
        this.modelos.set(modelosEncontrados);

        // Busca imagem em background para cada modelo listado
        modelosEncontrados.forEach(async (m) => {
          const cod = Number(m.codprod || m.codigo || 0);
          if (cod) {
            try {
              const responseBody: any = await this.respostaGateway(
                this.sankhyaGateway.buscarImgProdutoEdicao({ CODPROD: cod })
              );
              if (responseBody?.lista && responseBody.lista.length > 0) {
                const img = responseBody.lista[0].imagem;
                if (img) {
                  m.imagem = img;
                  // Força atualização reativa do sinal
                  this.modelos.set([...this.modelos()]);
                }
              }
            } catch (e) {
              // Ignora erro caso não tenha imagem
            }
          }
        });
      },
      error: (err) => {
        this.buscando.set(false);
        this.modelos.set([]);
        this.abrirAlerta('Falha ao buscar produtos modelo: ' + err.message, 'erro');
      }
    });
  }

  /** Exibe o restante dos produtos modelo encontrados. */
  verMaisModelos(): void {
    this.limiteModelos.set(this.modelos().length);
  }

  selecionarModelo(prod: ProdutoBusca, clonar = false): void {
    const codprod = Number(prod.codprod || prod.codigo || 0);
    if (!codprod) {
      this.abrirAlerta('Produto sem código válido', 'erro');
      return;
    }

    // Produtos MODELO (100000 a 100009) servem só de molde: não copiam descrição nem imagem.
    if (codprod >= 100000 && codprod <= 100009) clonar = false;

    this.produtoOrigem = prod;
    this.descrEstragEditadoManualmente = false;
    // Sem este reset, depois de digitar a Descrição uma vez (ou ao abrir outro modelo) a
    // tradução Label (USA) -> Descrição parava de funcionar.
    this.descricaoEditadaManualmente = false;
    this.loading.set(true);
    this.loadingMsg.set('Carregando dados do produto modelo...');

    // Carrega os dados do produto e os campos de imposto em paralelo
    forkJoin({
      produto: this.produtoService.buscarProdutoCompleto(codprod),
      impostos: this.produtoService.lerImpostosTGFPRO(String(codprod))
    }).subscribe({
      next: ({ produto: response, impostos }) => {
        this.impostosDoModelo = impostos;
        const dados = response.dados;
        const erro = response.erro;

        this.loading.set(false);
        if (erro || !dados || Object.keys(dados).length === 0) {
          this.abrirAlerta(erro || 'Não foi possível carregar os dados do produto modelo selecionado.', 'erro');
          return;
        }

        const campos: CampoDuplicacao[] = CAMPOS_DUPLICACAO.map((field) => ({
          field,
          label: CAMPO_LABELS[field] || field,
          valor: field === 'CODPROD' ? '' : (dados[field] ?? '')
        }));

        // Campos que devem começar vazios na clonagem (obrigatórios para o usuário preencher):
        // — DESCRPROD: cada produto deve ter descrição própria
        // — REFFORN: Part Number é específico do novo item
        // — REFERENCIA: chave única em TGFPRO (trigger impede duplicata)
        // — GPL_PN_ALTERNATIVO: PN alternativo é específico da peça, igual REFFORN
        //   (senão o novo produto nascia com o PN alternativo do modelo copiado)
        // — AD_OBSINT: A observação interna deve vir vazia (não herdar do modelo copiado)
        // Ao CLONAR (botão Clonar da Edição) a Descrição é mantida.
        const camposLimpar = ['DESCRPROD', 'REFFORN', 'REFERENCIA', 'GPL_PN_ALTERNATIVO', 'AD_OBSINT']
          .filter((f) => !(clonar && f === 'DESCRPROD'));
        for (const f of camposLimpar) {
          const c = campos.find((x) => x.field === f);
          if (c) c.valor = '';
        }

        if (this.pnAutoPreencher) {
          const cRefforn = campos.find((x) => x.field === 'REFFORN');
          if (cRefforn) {
            cRefforn.valor = this.pnAutoPreencher;
          }
          this.pnAutoPreencherConsumido.emit();
        }

        // A observação copiada do modelo não deve carregar a linha de cotação do modelo.
        const campoObsModelo = campos.find((c) => c.field === 'AD_OBSINT');
        if (campoObsModelo) campoObsModelo.valor = removerLinhasCotacao(campoObsModelo.valor);

        // Label (USA) sempre em maiúsculas
        const campoLabelMaiusc = campos.find((c) => c.field === 'GPL_LABEL');
        if (campoLabelMaiusc?.valor) campoLabelMaiusc.valor = String(campoLabelMaiusc.valor).toUpperCase();

        // Novo produto sempre inicia como Ativo
        const campoAtivo = campos.find((c) => c.field === 'ATIVO');
        if (campoAtivo) campoAtivo.valor = 'S';

        // Controle de estoque padrão: Número do Lote
        const campoTipContest = campos.find((c) => c.field === 'TIPCONTEST');
        if (campoTipContest) campoTipContest.valor = 'L';

        // Valores padrão para campos de exportação (editáveis pelo usuário)
        const campoEccn = campos.find((c) => c.field === 'AD_ECCN');
        if (campoEccn && !campoEccn.valor?.trim()) campoEccn.valor = '9A991';

        const campoScheduleB = campos.find((c) => c.field === 'AD_SCHEDULEB');
        if (campoScheduleB && !campoScheduleB.valor?.trim()) campoScheduleB.valor = '8409100040';

        // Pesos sempre iniciam zerados (não herdam do modelo)
        for (const f of ['PESOBRUTO', 'PESOLIQ']) {
          const c = campos.find((x) => x.field === f);
          if (c) c.valor = '0';
        }

        // AD_CONTROLAFORM e AD_CONTROLACORE sempre iniciam ativos
        const campoControlaForm = campos.find((c) => c.field === 'AD_CONTROLAFORM');
        if (campoControlaForm) campoControlaForm.valor = 'S';
        const campoControlaCore = campos.find((c) => c.field === 'AD_CONTROLACORE');
        if (campoControlaCore) campoControlaCore.valor = 'N';

        // GPL_MAT_PERIG/GPL_CONTROLADO (toggles "Perigoso"/"Controlado"): se o
        // modelo nunca teve o campo definido, vem '' (vazio) do Sankhya -- o
        // toggle renderiza desmarcado mas, sem um 'N' explícito, o backend
        // não manda nada pro Aerosys (converterSimNao('') = '', campo pulado)
        // e o produto novo fica sem gravar o "NÃO" explícito lá. Força 'N'
        // como padrão pra sempre mandar um valor explícito (SIM/NÃO) mesmo
        // quando o usuário não mexe no toggle.
        for (const f of ['GPL_MAT_PERIG', 'GPL_CONTROLADO']) {
          const c = campos.find((x) => x.field === f);
          if (c && c.valor !== 'S' && c.valor !== 'N') c.valor = 'N';
        }

        this.campos.set(campos);
        this.imagensPendentes = [];
        this.indexPadrao = -1;
        this.indexVisualizandoPendente = 0;
        this.mostrarModalSelecao = false;
        this.imagemPrincipal = null;   // imagem não herda do modelo
        this.listaImagens = [];
        if (clonar) void this.clonarImagensDoProduto(codprod);
        this.etapa.set('form');
        this._exibirAvisoInfoTemporario();


        // Guarda os valores de Margem de Custo/Lucro vindos do produto
        // modelo (TGFPRO) como "ponto de partida" para a sincronização
        // automática a partir da Marca (TGFMAR).
        this.ultimoValorSincronizadoMargemCusto = campos.find((c) => c.field === 'GPL_MARGEM_CUSTO')?.valor ?? '';
        this.ultimoValorSincronizadoMargemLucro = campos.find((c) => c.field === 'GPL_MARGEM_LUCRO')?.valor ?? '';

        // Bloco de preço/cotação (mesma tela): começa zerado, com Custo/Lucro
        // vindos das margens acima.
        this.reiniciarPrecoForm();

        // A Marca já vem preenchida (copiada do produto modelo), mas as
        // Margens de Custo/Lucro copiadas do modelo podem estar
        // desatualizadas em relação à margem cadastrada atualmente nessa
        // Marca (TGFMAR) — sincroniza já na abertura da tela, e não só
        // quando o usuário mexe no campo Marca.
        const campoMarcaInicial = campos.find((c) => c.field === 'CODMARCA');
        if (campoMarcaInicial?.valor?.trim()) {
          this.atualizarMargensPorMarca(campoMarcaInicial.valor);
        }

        // Se a Descrição já vier preenchida e o Label (USA) ainda estiver
        // vazio, traduz automaticamente PT -> EN (falha silenciosa).
        const campoDescricao = campos.find((c) => c.field === 'DESCRPROD');
        const campoLabelUsa = campos.find((c) => c.field === 'GPL_LABEL');
        if (campoDescricao?.valor && !campoLabelUsa?.valor) {
          this.traduzirDescricao(campoDescricao.valor);
        }

        // Busca a descrição do Local Padrão atual para exibição imediata
        // (antes de a lista completa de locais terminar de carregar).
        const campoLocal = campos.find((c) => c.field === 'CODLOCALPADRAO');
        if (campoLocal?.valor) {
          this.produtoService.buscarDescricaoLocal(campoLocal.valor).subscribe({
            next: (labelCompleto) => {
              // buscarDescricaoLocal retorna "codigo - descricao" ou só o codigo
              const partes = labelCompleto.split(' - ');
              this._descricaoLocalAtual = partes.length > 1 ? partes.slice(1).join(' - ') : '';
              this.campos.set([...this.campos()]);
            }
          });
        }

        // Busca a descrição do NCM atual para exibição imediata.
        const campoNcm = campos.find((c) => c.field === 'NCM');
        if (campoNcm?.valor) {
          this.produtoService.buscarDescricaoNcm(campoNcm.valor).subscribe({
            next: (desc) => {
              this._descricaoNcmAtual = desc;
              this.campos.set([...this.campos()]);
            }
          });
        }

        // Nome/Sigla em inglês das unidades (TGFVOL.GPL_NOMEINGLES/GPL_SIGLAINGLES)
        // -- alimenta o campo "Unit of Measure" em "Dados Internacionais".
        this.produtoService.buscarUnidadesMedidaIngles().subscribe({
          next: (lista) => this.unidadesIngles.set(lista ?? []),
          error: () => this.unidadesIngles.set([])
        });

        // Carrega as Unidades de Medida (TGFVOL) para exibir o campo
        // "Unidade (Volume)" como um <select>, igual ao Sankhya.
        this.produtoService.buscarUnidadesMedida().subscribe({
          next: (opcoes) => {
            if (!opcoes.length) {
              return;
            }
            const atual = this.campos().find((c) => c.field === 'CODVOL');
            if (atual) {
              atual.opcoes = opcoes;
              // garante que o valor atual exista entre as opções carregadas
              if (atual.valor && !opcoes.some((o) => o.valor === atual.valor)) {
                opcoes.push({ valor: atual.valor, label: atual.valor });
              }
              this.campos.set([...this.campos()]);
            }
          }
        });

        // Carrega as opções do campo "Lista de Opções" AD_CONDICAO (CD)
        // para exibir como <select>.
        this.produtoService.buscarOpcoesCondicao().subscribe({
          next: (opcoes) => {
            if (!opcoes.length) {
              return;
            }
            const atual = this.campos().find((c) => c.field === 'AD_CONDICAO');
            if (atual) {
              atual.opcoes = opcoes;
              if (atual.valor && !opcoes.some((o) => o.valor === atual.valor)) {
                opcoes.push({ valor: atual.valor, label: atual.valor });
              }
              this.campos.set([...this.campos()]);
            }
          }
        });

        // Carrega as Marcas (TGFMAR) para alimentar o modal "Procurando por
        // Marca" (campo CODMARCA), igual ao Sankhya.
        this.produtoService.buscarMarcas().subscribe({
          next: (opcoes) => {
            this.marcas.set(opcoes);
          }
        });

        // Carrega os Grupos de Produto para alimentar o modal "Procurando
        // por Grupo de Produto" (campo CODGRUPOPROD), igual ao Sankhya.
        this.produtoService.buscarGruposProduto().subscribe({
          next: (opcoes) => {
            this.grupos.set(opcoes);
          }
        });

        // Carrega os Locais de Estoque (TGFLOC) para alimentar o modal
        // "Procurando por Local" (campo CODLOCALPADRAO).
        this.produtoService.buscarLocais().subscribe({
          next: (opcoes) => {
            this.locais.set(opcoes);
          }
        });

        // Carrega os NCMs (TGFNCM) para alimentar o modal "Procurando
        // por NCM" (campo NCM).
        this.produtoService.buscarNcms().subscribe({
          next: (opcoes) => {
            this.ncms.set(opcoes);
          }
        });
      },
      error: (err) => {
        this.loading.set(false);
        this.abrirAlerta('Erro ao carregar produto modelo: ' + err.message, 'erro');
      }
    });
  }

  onToggleAtivo(campo: CampoDuplicacao, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    campo.valor = checked ? 'S' : 'N';
    if (campo.field === 'AD_CONTROLACORE' && !checked) this.precoForm.valorCore = '0.00';
    this.campos.set([...this.campos()]);
  }

  /**
   * Campo Descrição (DESCRPROD): atualiza o valor e agenda a tradução
   * automática PT -> EN com debounce de 300ms enquanto o usuário digita.
   */
  onDescricaoChange(campo: CampoDuplicacao, valor: string): void {
    valor = (valor ?? '').toUpperCase();
    campo.valor = valor;
    this.descricaoEditadaManualmente = true;

    if (this.descrEstragEditadoManualmente) {
      return;
    }

    if (this.traducaoTimer) {
      clearTimeout(this.traducaoTimer);
    }
    this.traducaoTimer = setTimeout(() => this.traduzirDescricao(valor), 300);
  }

  /**
   * Campo Label (USA) (DESCRESTRAG): atualiza o valor e marca como editado
   * manualmente, para que a tradução automática não sobrescreva o que o
   * usuário digitou.
   */
  onLabelUsaChange(campo: CampoDuplicacao, valor: string): void {
    campo.valor = (valor ?? '').toUpperCase();
    valor = campo.valor;
    this.descrEstragEditadoManualmente = true;

    if (this.descricaoEditadaManualmente) {
      return;
    }

    if (this.traducaoEnPtTimer) {
      clearTimeout(this.traducaoEnPtTimer);
    }
    this.traducaoEnPtTimer = setTimeout(() => this.traduzirLabelUsa(valor), 300);
  }

  /**
   * Traduz a Descrição (PT) para o Label (USA) (EN) via API de tradução.
   * Falha (timeout, serviço indisponível, etc.) é tratada silenciosamente
   * — não exibe alerta nem interrompe o preenchimento do formulário.
   */
  private traduzirDescricao(texto: string): void {
    const valor = (texto || '').trim();
    if (!valor || this.descrEstragEditadoManualmente) {
      return;
    }

    // @ts-ignore
    this.produtoService.traduzirParaIngles(valor).subscribe({
      next: (response: any) => {

        const traducao = response.traducao;
        const sucesso = response.sucesso;

        if (!sucesso || !traducao || this.descrEstragEditadoManualmente) {
          return;
        }
        const campoLabel = this.campos().find((c) => c.field === 'GPL_LABEL');
        if (campoLabel) {
          campoLabel.valor = String(traducao).toUpperCase();
          this.campos.set([...this.campos()]);
        }
      },
      error: () => {
        // Falha silenciosa: não interrompe o preenchimento do formulário.
      }
    });
  }

  /**
   * Traduz o Label (USA) (EN) para a Descrição (PT) via API de tradução.
   */
  private traduzirLabelUsa(texto: string): void {
    const valor = (texto || '').trim();
    if (!valor || this.descricaoEditadaManualmente) {
      return;
    }

    // @ts-ignore
    this.produtoService.traduzirParaPortugues(valor).subscribe({
      next: (response: any) => {

        const traducao = response.traducao;
        const sucesso = response.sucesso;

        if (!sucesso || !traducao || this.descricaoEditadaManualmente) {
          return;
        }
        const campoDescricao = this.campos().find((c) => c.field === 'DESCRPROD');
        if (campoDescricao) {
          campoDescricao.valor = String(traducao).toUpperCase();
          this.campos.set([...this.campos()]);
        }
      },
      error: () => {
        // Falha silenciosa
      }
    });
  }

  /**
   * Marca/desmarca os checkboxes genéricos (ex.: Perigoso), gravando 'S'/'N'.
   */
  onToggleCheckbox(campo: CampoDuplicacao, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    campo.valor = checked ? 'S' : 'N';
    this.campos.set([...this.campos()]);
  }

  /**
   * Toggle "Controlado" (GPL_CONTROLADO): além de marcar 'S'/'N', preenche
   * automaticamente Limite PF = 5 e Limite PJ = 200 ao habilitar, e limpa
   * ao desabilitar. Os campos de limite são sempre somente-leitura na tela.
   */
  onToggleControlado(campo: CampoDuplicacao, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    campo.valor = checked ? 'S' : 'N';

    const limPF = this.campos().find((c) => c.field === 'GPL_CTRL_LIM_PF');
    const limPJ = this.campos().find((c) => c.field === 'GPL_CTRL_LIM_PJ');

    if (checked) {
      if (limPF) limPF.valor = '5.00';
      if (limPJ) limPJ.valor = '200.00';
    } else {
      if (limPF) limPF.valor = '';
      if (limPJ) limPJ.valor = '';
    }

    this.campos.set([...this.campos()]);
  }

  /**
   * Alterna o campo "Tipo de Controle de Estoque" (TIPCONTEST) entre "Série"
   * (valor 'E') e "Número do Lote" (valor 'L'). Os dois toggles são
   * mutuamente exclusivos por construção: ambos refletem o mesmo campo
   * TIPCONTEST, então ativar um automaticamente "desmarca" o outro. Ao
   * desativar o toggle ativo, o valor volta para 'N' (Sem controle
   * adicional), opção válida do domínio do campo.
   */
  onToggleTipoControle(campo: CampoDuplicacao, valorOpcao: 'E' | 'L', event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    campo.valor = checked ? valorOpcao : 'N';
    this.campos.set([...this.campos()]);
  }

  /**
   * Remove espaços em branco do início e do fim do valor do campo ao sair
   * dele (blur). Chamado no (blur) de todos os inputs de texto do formulário.
   */
  trimCampo(campo: CampoDuplicacao): void {
    if (typeof campo.valor === 'string') {
      campo.valor = campo.valor.trim();
      this.campos.set([...this.campos()]);
    }
  }

  /**
   * Indica se o checkbox "Controlado" (GPL_CONTROLADO) está marcado. Usado
   * para habilitar/desabilitar os campos "Limite PF" (GPL_CTRL_LIM_PF) e
   * "Limite PJ" (GPL_CTRL_LIM_PJ).
   */
  controladoAtivo(): boolean {
    return this.campos().find((c) => c.field === 'GPL_CONTROLADO')?.valor === 'S';
  }

  /**
   * Retorna o campo correspondente a um nome específico. Usado para
   * renderizar campos em posições fixas no layout (linhas de
   * Código/Descrição/PN, Unidade/Marca/Grupo e Perigoso/Controlado/Limites).
   */
  campoPorField(field: string): CampoDuplicacao | undefined {
    return this.campos().find((c) => c.field === field);
  }

  /**
   * Campos com posição fixa no layout (renderizados em blocos próprios) e
   * que, portanto, devem ser ignorados pelo *ngFor genérico que renderiza os
   * demais campos.
   */
  private readonly camposLayoutFixo = new Set([
    'ATIVO',
    'CODPROD',
    'DESCRPROD',
    'GPL_LABEL',
    'AD_SCHEDULEB',
    'AD_ECCN',
    'TIPCONTEST',
    'REFFORN',
    'GPL_PN_ALTERNATIVO',
    'CODVOL',
    'AD_CONDICAO',
    'CODMARCA',
    'MARCA',
    'CODGRUPOPROD',
    'GPL_MAT_PERIG',
    'GPL_CONTROLADO',
    'GPL_CTRL_LIM_PF',
    'GPL_CTRL_LIM_PJ',
    'GPL_MARGEM_CUSTO',
    'GPL_MARGEM_LUCRO',
    'CODLOCALPADRAO',
    'NCM',
    'PESOBRUTO',
    'PESOLIQ',
    // Campos ocultos da tela (mantidos em CAMPOS_DUPLICACAO para copiar o
    // valor do produto modelo automaticamente na gravação):
    'COMPLDESC',
    'USOPROD',
    'REFERENCIA',
    // Campos fiscais IPI — copiados silenciosamente do produto modelo:
    'CSTIPIENT',
    'CSTIPISAI',
    'CODIPI',
    'CODENQIPIENT',
    'CODENQIPISAI',
    'TEMIPICOMPRA',
    'TEMIPIVENDA',
    'CLASSUBTRIB',
    'CODCLASTRIBNAC',
    'AD_CONTROLAFORM',
    'AD_CONTROLACORE',
    'AD_OBSINT',
    'AD_OBSTEC',
  ]);

  emLayoutFixo(field: string): boolean {
    return this.camposLayoutFixo.has(field);
  }

  /**
   * Aplica uma máscara de valor monetário aos campos "Limite PF" e "Limite
   * PJ": os dígitos digitados são tratados como centavos (ex.: "12345" ->
   * "123,45"), igual à máscara usada em campos de valor do Sankhya.
   * `campo.valor` fica sempre com ponto decimal (ex.: "123.45"), formato
   * aceito ao salvar; a exibição em tela usa `valorExibidoLimite`.
   */
  onInputDecimal(event: Event, campo: CampoDuplicacao): void {
    const input = event.target as HTMLInputElement;
    const digitos = input.value.replace(/\D/g, '');

    if (!digitos) {
      campo.valor = '';
      input.value = '';
      return;
    }

    const numero = Number(digitos) / 100;
    campo.valor = numero.toFixed(2);
    input.value = this.formatarValorMonetario(campo.valor);
  }

  /** Formata "123.45" como "123,45" (padrão monetário BR) para exibição. */
  valorExibidoLimite(valor: string): string {
    if (!valor) {
      return '';
    }
    return this.formatarValorMonetario(valor);
  }

  // ── Máscara de percentual para Margem de Custo / Margem de Lucro ──────────

  /** Formata o valor numérico como percentual para exibição (ex: '15.5' → '15,50 %'). */
  formatarMargem(valor: string): string {
    if (!valor?.trim()) return '';
    const num = parseFloat(valor.replace(',', '.'));
    if (isNaN(num)) return valor;
    return num.toFixed(2).replace('.', ',') + ' %';
  }

  /** Ao focar no campo de margem remove a máscara, deixa só o número para edição. */
  onFocusMargem(event: Event): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value.replace('%', '').replace(/\s/g, '').replace(',', '.').trim();
    const num = parseFloat(raw);
    input.value = isNaN(num) ? '' : String(num).replace('.', ',');
    input.select();
  }

  /** Ao sair do campo de margem formata como percentual e persiste o valor no campo. */
  onBlurMargem(event: Event, campo: CampoDuplicacao): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value.replace('%', '').replace(/\s/g, '').replace(',', '.').trim();
    const num = parseFloat(raw);
    if (!isNaN(num)) {
      campo.valor = num.toFixed(2);
      input.value = num.toFixed(2).replace('.', ',') + ' %';
    } else {
      campo.valor = '';
      input.value = '';
    }
    this.campos.set([...this.campos()]);
  }

  // ───────────────────────────────────────────────────────────────────────────

  private formatarValorMonetario(valor: string): string {
    const numero = Number(valor);
    if (isNaN(numero)) {
      return '';
    }
    return numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /** Retorna a descrição da Marca (CODMARCA) para exibir ao lado do código. */
  descricaoMarca(codigo: string): string {
    const codigoAtual = (codigo || '').trim();

    // Procura primeiro na lista de marcas carregada (cobre o caso de o
    // usuário digitar/alterar o código manualmente).
    const opcao = this.marcas().find((m) => m.valor === codigoAtual);
    if (opcao) {
      const partes = opcao.label.split(' - ');
      return partes.length > 1 ? partes.slice(1).join(' - ') : '';
    }

    // Fallback: valor já carregado no campo oculto 'MARCA' (descrição do
    // produto modelo original), usado enquanto a lista de marcas não
    // tiver sido carregada ainda ou não contiver o código atual.
    const campoMarca = this.campos().find((c) => c.field === 'MARCA');
    const campoCodMarca = this.campos().find((c) => c.field === 'CODMARCA');
    if (campoMarca && campoMarca.valor && campoCodMarca && (campoCodMarca.valor || '').trim() === codigoAtual) {
      return campoMarca.valor.trim();
    }

    return '';
  }

  /**
   * Valor exibido no input do campo CODMARCA: "CÓDIGO - Descrição" (igual
   * ao Sankhya), ou apenas o código quando não há descrição encontrada.
   */
  /** Retorna o label completo de uma opção pelo valor, para usar em [title]. */
  labelOpcao(campo: CampoDuplicacao, valor: string): string {
    if (!valor || !campo.opcoes?.length) return valor || '';
    return campo.opcoes.find((o) => o.valor === valor)?.label ?? valor;
  }

  valorExibidoMarca(codigo: string): string {
    const codigoAtual = (codigo || '').trim();
    const descricao = this.descricaoMarca(codigoAtual);
    return descricao ? `${codigoAtual} - ${descricao}` : codigoAtual;
  }

  /**
   * Chamado a cada tecla digitada no campo CODMARCA. Como o input exibe
   * "CÓDIGO - Descrição", considera-se código apenas o trecho antes do
   * primeiro " - " (a descrição é recalculada e reanexada automaticamente).
   * Mantém também o campo oculto 'MARCA' sincronizado e o cursor posicionado
   * dentro do trecho do código.
   */
  onInputMarca(event: Event, campo: CampoDuplicacao): void {
    const input = event.target as HTMLInputElement;
    const valorDigitado = input.value;
    const cursorPos = input.selectionStart ?? valorDigitado.length;

    const idx = valorDigitado.indexOf(' - ');
    const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;

    campo.valor = novoCodigo;

    const campoMarca = this.campos().find((c) => c.field === 'MARCA');
    if (campoMarca) {
      campoMarca.valor = this.descricaoMarca(novoCodigo);
    }

    // Preenche Margem de Custo/Lucro assim que o código digitado bater com
    // uma marca já carregada -- sem esperar sair do campo (blur). Só usa a
    // lista em memória aqui (permitirBuscaRemota=false); o fallback via
    // HTTP pra marcas fora dessa lista só roda no blur (onBlurMarca).
    this.atualizarMargensPorMarca(novoCodigo, false);

    // Reescreve o valor exibido (código + descrição atualizada) e
    // reposiciona o cursor dentro do trecho do código, após o binding
    // [value] ser reaplicado pelo Angular.
    const novoValor = this.valorExibidoMarca(novoCodigo);
    setTimeout(() => {
      input.value = novoValor;
      const novaPos = Math.min(cursorPos, novoCodigo.length);
      input.setSelectionRange(novaPos, novaPos);
    });
  }

  /**
   * Ao focar o campo CODMARCA (clique ou tab): limpa só o texto VISÍVEL do
   * input, sem mexer em campo.valor -- assim o usuário já começa a digitar
   * um código novo do zero, em vez de o clique cair no meio de "1 -
   * MISCELANEOUS" e o texto digitado ficar misturado com a descrição
   * antiga (o que gerava um código inválido e, por tabela, a Margem de
   * Custo/Lucro nunca batia com nenhuma marca real). Se o usuário sair do
   * campo sem digitar nada, onBlurMarca restaura o texto exibido.
   */
  onFocusMarca(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = '';
  }

  /** Foca o campo de pesquisa do modal de busca recém-aberto. */
  private focarInputModalBusca(): void {
    setTimeout(() => (document.querySelector('.modal-overlay .busca-modal-input') as HTMLInputElement | null)?.focus(), 50);
  }

  abrirBuscaMarca(): void {
    this.marcaModalDestino = 'produto';
    this.filtroMarca.set('');
    this.marcaModalAberta.set(true);
    this.focarInputModalBusca();
  }

  fecharBuscaMarca(): void {
    this.marcaModalAberta.set(false);
    this.marcaModalDestino = 'produto';
  }

  selecionarMarca(opcao: OpcaoCampo): void {
    if (this.marcaModalDestino === 'alternativo') {
      const partes = opcao.label.split(' - ');
      this.marcaProdutoAlternativo = opcao.valor;
      this.marcaProdutoAlternativoDescricao = partes.length > 1 ? partes.slice(1).join(' - ') : opcao.label;
      this.marcaModalAberta.set(false);
      this.marcaModalDestino = 'produto';
      void this.buscarProdutosAlternativosModal();
      return;
    }
    const atual = this.campos().find((c) => c.field === 'CODMARCA');
    if (atual) {
      atual.valor = opcao.valor;
    }

    // Atualiza também o campo oculto 'MARCA' com a descrição, para exibição.
    const partes = opcao.label.split(' - ');
    const descricao = partes.length > 1 ? partes.slice(1).join(' - ') : '';
    const campoMarca = this.campos().find((c) => c.field === 'MARCA');
    if (campoMarca) {
      campoMarca.valor = descricao;
    }

    this.campos.set([...this.campos()]);
    this.marcaModalAberta.set(false);
    this.atualizarMargensPorMarca(opcao.valor);
  }

  limparMarca(campo: CampoDuplicacao): void {
    campo.valor = '';

    const campoMarca = this.campos().find((c) => c.field === 'MARCA');
    if (campoMarca) {
      campoMarca.valor = '';
    }

    this.campos.set([...this.campos()]);
  }

  /**
   * Chamado quando o campo Marca (CODMARCA) perde o foco, para o caso de o
   * código ter sido digitado manualmente (sem usar o modal de busca).
   * Atualiza "Margem de Custo"/"Margem de Lucro" conforme a marca, desde
   * que esses campos não tenham sido editados manualmente.
   *
   * Se o usuário só focou o campo (onFocusMarca limpou o texto exibido) e
   * saiu sem digitar nada, o input fica vazio na tela mesmo com campo.valor
   * intacto -- restaura o texto exibido nesse caso (o [value] do Angular
   * não reaplica sozinho quando o valor do campo não mudou entre ciclos).
   */
  onBlurMarca(event: Event, campo: CampoDuplicacao): void {
    this.atualizarMargensPorMarca(campo.valor);
    const input = event.target as HTMLInputElement;
    input.value = this.valorExibidoMarca(campo.valor);
  }

  /**
   * Busca AD_CUSTO/AD_LUCRO da Marca (TGFMAR) e atualiza os campos
   * GPL_MARGEM_CUSTO e GPL_MARGEM_LUCRO do produto, repetindo o
   * comportamento da TGFMAR sempre que a Marca for alterada.
   *
   * Cada campo só é atualizado se seu valor atual ainda for igual ao
   * "último valor sincronizado" (`ultimoValorSincronizadoMargemCusto` /
   * `ultimoValorSincronizadoMargemLucro`) — ou seja, ainda é o valor que veio
   * do produto modelo (TGFPRO) ou de uma atualização automática anterior.
   * Se o valor foi alterado manualmente pelo usuário, fica diferente do
   * último sincronizado e NÃO é sobrescrito. A verificação é feita de forma
   * independente para cada campo.
   */
  /**
   * @param permitirBuscaRemota Quando `false` (chamado a cada tecla
   * digitada, ver onInputMarca), só usa a lista de Marcas já carregada em
   * memória -- nunca dispara requisição HTTP por tecla, o que spammaria o
   * backend com um código incompleto/inválido a cada caractere. A busca
   * remota completa (fallback pra marcas fora da lista cacheada) só
   * acontece de verdade no blur (onBlurMarca chama com o padrão `true`).
   */
  private atualizarMargensPorMarca(codMarca: string, permitirBuscaRemota: boolean = true): void {
    const codigo = (codMarca || '').trim().split(' - ')[0].trim();
    if (!codigo) {
      return;
    }

    // A lista de Marcas (carregada uma única vez para alimentar o modal
    // "Procurando por Marca") já vem com AD_CUSTO/AD_LUCRO de TGFMAR —
    // usa esses dados diretamente, sem nova consulta.
    const marcaCache = this.marcas().find((m) => m.valor === codigo);
    if (marcaCache && (marcaCache.custo !== undefined || marcaCache.lucro !== undefined)) {
      // eslint-disable-next-line no-console
      console.log('[DuplicarProduto] atualizarMargensPorMarca: margens (cache) =', marcaCache);
      this.aplicarMargens({ custo: marcaCache.custo ?? '', lucro: marcaCache.lucro ?? '' });
      return;
    }

    if (!permitirBuscaRemota) {
      return;
    }

    // eslint-disable-next-line no-console
    console.log('[DuplicarProduto] atualizarMargensPorMarca: buscando margens para CODMARCA =', codigo);

    this.produtoService.buscarMargensMarca(codigo).subscribe({
      next: (margens) => {
        // eslint-disable-next-line no-console
        console.log('[DuplicarProduto] atualizarMargensPorMarca: margens recebidas =', margens);

        // Mesmo sem cadastro (null/custo e lucro vazios), aplica -- aplicarMargens()
        // já trata esse caso zerando os campos e o aviso "sem cadastro" é
        // resolvido pelo cache de marcas() (margemMarcaSemCadastro).
        this.aplicarMargens(margens ?? { custo: '', lucro: '' });
      },
      error: (err) => {
        // eslint-disable-next-line no-console
        console.log('[DuplicarProduto] atualizarMargensPorMarca: erro =', err);
      }
    });
  }

  /**
   * Margem de Custo/Lucro cadastrada na Marca atual (TGFMAR.AD_CUSTO/
   * AD_LUCRO), para exibição auxiliar abaixo do campo Marca. Retorna
   * `null` se a marca não estiver na lista carregada ou não tiver esses
   * valores cadastrados.
   */
  margemMarcaAtual(codigo: string): { custo: string; lucro: string } | null {
    const codigoAtual = (codigo || '').trim().split(' - ')[0].trim();
    if (!codigoAtual) {
      return null;
    }

    const opcao = this.marcas().find((m) => m.valor === codigoAtual);
    if (!opcao) {
      return null;
    }

    const temCusto = !!opcao.custo?.toString().trim();
    const temLucro = !!opcao.lucro?.toString().trim();
    if (!temCusto && !temLucro) {
      // Marca encontrada, mas sem nenhuma das duas margens cadastradas --
      // não mostra a caixa informativa em branco, ver margemMarcaSemCadastro().
      return null;
    }

    return { custo: opcao.custo ?? '', lucro: opcao.lucro ?? '' };
  }

  /**
   * `true` quando a Marca atual foi encontrada na lista carregada (TGFMAR),
   * mas não tem nenhuma Margem de Custo/Lucro cadastrada -- usado para
   * exibir o aviso em vermelho abaixo do campo Marca (em vez da caixa azul
   * com percentuais em branco).
   */
  margemMarcaSemCadastro(codigo: string): boolean {
    const codigoAtual = (codigo || '').trim().split(' - ')[0].trim();
    if (!codigoAtual) {
      return false;
    }

    const opcao = this.marcas().find((m) => m.valor === codigoAtual);
    if (!opcao) {
      return false;
    }

    return !opcao.custo?.toString().trim() && !opcao.lucro?.toString().trim();
  }

  /**
   * Aplica os valores de "Margem de Custo"/"Margem de Lucro" recebidos da
   * Marca (TGFMAR) aos campos GPL_MARGEM_CUSTO/GPL_MARGEM_LUCRO do produto,
   * respeitando a verificação de "último valor sincronizado" (ver
   * `atualizarMargensPorMarca`).
   */
  private aplicarMargens(margens: { custo: string; lucro: string }): void {
    // Quando a Marca não tem margem cadastrada (TGFMAR), preenche com 0
    // em vez de deixar o campo em branco -- o aviso "sem cadastro" é
    // exibido à parte, ver margemMarcaSemCadastro().
    const custoFinal = margens.custo?.toString().trim() || '0.00';
    const lucroFinal = margens.lucro?.toString().trim() || '0.00';

    const campoCusto = this.campos().find((c) => c.field === 'GPL_MARGEM_CUSTO');
    if (campoCusto && (campoCusto.valor === this.ultimoValorSincronizadoMargemCusto || !campoCusto.valor?.trim())) {
      campoCusto.valor = custoFinal;
      this.ultimoValorSincronizadoMargemCusto = custoFinal;
    }

    const campoLucro = this.campos().find((c) => c.field === 'GPL_MARGEM_LUCRO');
    if (campoLucro && (campoLucro.valor === this.ultimoValorSincronizadoMargemLucro || !campoLucro.valor?.trim())) {
      campoLucro.valor = lucroFinal;
      this.ultimoValorSincronizadoMargemLucro = lucroFinal;
    }

    this.campos.set([...this.campos()]);
    this.sincronizarPrecoComMargens();
  }

  /**
   * Retorna o campo CODGRUPOPROD (Grupo de Produto), usado para renderizá-lo
   * lado a lado com o campo CODMARCA (Marca) no formulário.
   */
  campoGrupo(): CampoDuplicacao | undefined {
    return this.campos().find((c) => c.field === 'CODGRUPOPROD');
  }

  /** Retorna a descrição do Grupo de Produto (CODGRUPOPROD) para exibir junto ao código. */
  descricaoGrupo(codigo: string): string {
    const codigoAtual = (codigo || '').trim();
    if (!codigoAtual) {
      return '';
    }
    // Compara primeiro como texto e, se não encontrar, como número (cobre
    // diferenças de formatação como zeros à esquerda, ex.: "010000" vs "10000").
    const opcao = this.grupos().find((g) => g.valor === codigoAtual)
      || this.grupos().find((g) => Number(g.valor) === Number(codigoAtual) && !isNaN(Number(codigoAtual)));
    if (!opcao) {
      return '';
    }
    const partes = opcao.label.split(' - ');
    return partes.length > 1 ? partes.slice(1).join(' - ') : '';
  }

  /**
   * Valor exibido no input do campo CODGRUPOPROD: "CÓDIGO - Descrição"
   * (igual ao Sankhya), ou apenas o código quando não há descrição encontrada.
   */
  valorExibidoGrupo(codigo: string): string {
    const codigoAtual = (codigo || '').trim();
    const descricao = this.descricaoGrupo(codigoAtual);
    return descricao ? `${codigoAtual} - ${descricao}` : codigoAtual;
  }

  /**
   * Chamado a cada tecla digitada no campo CODGRUPOPROD. Igual ao
   * onInputMarca: considera código apenas o trecho antes do primeiro " - ",
   * recalcula e reanexa a descrição, e mantém o cursor na posição correta.
   */
  onInputGrupo(event: Event, campo: CampoDuplicacao): void {
    const input = event.target as HTMLInputElement;
    const valorDigitado = input.value;
    const cursorPos = input.selectionStart ?? valorDigitado.length;

    const idx = valorDigitado.indexOf(' - ');
    const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;

    campo.valor = novoCodigo;

    const novoValor = this.valorExibidoGrupo(novoCodigo);
    setTimeout(() => {
      input.value = novoValor;
      const novaPos = Math.min(cursorPos, novoCodigo.length);
      input.setSelectionRange(novaPos, novaPos);
    });
  }

  abrirBuscaGrupo(): void {
    this.filtroGrupo.set('');
    this.grupoModalAberta.set(true);
    this.focarInputModalBusca();
  }

  fecharBuscaGrupo(): void {
    this.grupoModalAberta.set(false);
  }

  selecionarGrupo(opcao: OpcaoCampo): void {
    const atual = this.campos().find((c) => c.field === 'CODGRUPOPROD');
    if (atual) {
      atual.valor = opcao.valor;
      this.campos.set([...this.campos()]);
    }
    this.grupoModalAberta.set(false);
  }

  limparGrupo(campo: CampoDuplicacao): void {
    campo.valor = '';
    this.campos.set([...this.campos()]);
  }

  // ── Local de Estoque (CODLOCALPADRAO) ────────────────────────────────────

  descricaoLocal(codigo: string): string {
    const opcao = this.locais().find((l) => l.valor === (codigo || '').trim());
    if (opcao) {
      const partes = opcao.label.split(' - ');
      return partes.length > 1 ? partes.slice(1).join(' - ') : '';
    }
    // Fallback: descrição carregada individualmente ao abrir o produto.
    return this._descricaoLocalAtual;
  }

  valorExibidoLocal(codigo: string): string {
    const codigoAtual = (codigo || '').trim();
    const descricao = this.descricaoLocal(codigoAtual);
    return descricao ? `${codigoAtual} - ${descricao}` : codigoAtual;
  }

  onInputLocal(event: Event, campo: CampoDuplicacao): void {
    const input = event.target as HTMLInputElement;
    const valorDigitado = input.value;
    const cursorPos = input.selectionStart ?? valorDigitado.length;
    const idx = valorDigitado.indexOf(' - ');
    const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;
    campo.valor = novoCodigo;
    const novoValor = this.valorExibidoLocal(novoCodigo);
    setTimeout(() => {
      input.value = novoValor;
      const novaPos = Math.min(cursorPos, novoCodigo.length);
      input.setSelectionRange(novaPos, novaPos);
    });
  }

  abrirBuscaLocal(): void {
    this.filtroLocal.set('');
    this.localModalAberta.set(true);
    this.focarInputModalBusca();
  }

  fecharBuscaLocal(): void {
    this.localModalAberta.set(false);
  }

  selecionarLocal(opcao: OpcaoCampo): void {
    const atual = this.campos().find((c) => c.field === 'CODLOCALPADRAO');
    if (atual) {
      atual.valor = opcao.valor;
      this._descricaoLocalAtual = '';  // a lista já tem a descrição correta
      this.campos.set([...this.campos()]);
    }
    this.localModalAberta.set(false);
  }

  limparLocal(campo: CampoDuplicacao): void {
    campo.valor = '';
    this.campos.set([...this.campos()]);
  }

  // ── NCM ───────────────────────────────────────────────────────────────────

  descricaoNcm(codigo: string): string {
    const opcao = this.ncms().find((n) => n.valor === (codigo || '').trim());
    if (opcao) {
      const partes = opcao.label.split(' - ');
      return partes.length > 1 ? partes.slice(1).join(' - ') : '';
    }
    // Fallback: descrição carregada individualmente ao abrir o produto.
    return this._descricaoNcmAtual;
  }

  valorExibidoNcm(codigo: string): string {
    const codigoAtual = (codigo || '').trim();
    const descricao = this.descricaoNcm(codigoAtual);
    return descricao ? `${codigoAtual} - ${descricao}` : codigoAtual;
  }

  onInputNcm(event: Event, campo: CampoDuplicacao): void {
    const input = event.target as HTMLInputElement;
    const valorDigitado = input.value;
    const cursorPos = input.selectionStart ?? valorDigitado.length;
    const idx = valorDigitado.indexOf(' - ');
    const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;
    campo.valor = novoCodigo;
    const novoValor = this.valorExibidoNcm(novoCodigo);
    setTimeout(() => {
      input.value = novoValor;
      const novaPos = Math.min(cursorPos, novoCodigo.length);
      input.setSelectionRange(novaPos, novaPos);
    });
  }

  abrirBuscaNcm(): void {
    this.filtroNcm.set('');
    this.ncmModalAberta.set(true);
    this.focarInputModalBusca();
  }

  fecharBuscaNcm(): void {
    this.ncmModalAberta.set(false);
  }

  selecionarNcm(opcao: OpcaoCampo): void {
    const atual = this.campos().find((c) => c.field === 'NCM');
    if (atual) {
      atual.valor = opcao.valor;
      this._descricaoNcmAtual = '';  // a lista já tem a descrição correta
      this.campos.set([...this.campos()]);
    }
    this.ncmModalAberta.set(false);
  }

  limparNcm(campo: CampoDuplicacao): void {
    campo.valor = '';
    this.campos.set([...this.campos()]);
  }

  /** Cancelar: se o Clonar veio da Lista/Edição, volta pra ela; senão volta à seleção de modelos. */
  voltarLista(): void {
    if (this.origemRetorno) {
      this.voltarParaOrigem();
      return;
    }
    this.etapa.set('lista');
    this.produtoOrigem = null;
    this.campos.set([]);
  }

  /** Botão "Salvar": valida e abre o modal "Copiar Também". */
  salvar(): void {
    const descricao = this.campos().find((c) => c.field === 'DESCRPROD');
    if (!descricao?.valor?.trim() || descricao.valor.trim().length < 5) {
      this.abrirAlerta('A Descrição é obrigatória e deve ter ao menos 5 caracteres.', 'aviso');
      return;
    }

    const refforn = this.campos().find((c) => c.field === 'REFFORN');
    if (!refforn?.valor?.trim() || refforn.valor.trim().length < 3) {
      this.abrirAlerta('O PN (Part Number) é obrigatório e deve ter ao menos 3 caracteres.', 'aviso');
      return;
    }

    const dados: Record<string, string> = {};
    this.campos().forEach((c) => {
      if (c.field !== 'CODPROD') {
        dados[c.field] = (c.valor ?? '').toString().trim();
      }
    });

    // Garante que MARCA (descrição) nunca fique vazia quando CODMARCA está preenchido.
    // TGFPRO pode ter CODMARCA sem MARCA preenchida; o DatasetSP.save exige MARCA.
    if (!dados['MARCA'] && dados['CODMARCA']) {
      dados['MARCA'] = this.descricaoMarca(dados['CODMARCA']);
    }

    this._dadosPendentesParaSalvar = dados;

    // A precificação agora fica na MESMA tela (sem a antiga etapa "Próximo"):
    // preço informado exige o fornecedor (Cotação Realizada Em) e já segue
    // direto para a gravação.
    this.confirmarSalvarComPreco();
  }

  /**
   * Zera o bloco de preço/cotação (nova tela única) e preenche Custo (%) e
   * Lucro (%) com as margens do produto/Marca (campos GPL_MARGEM_CUSTO/
   * GPL_MARGEM_LUCRO, que continuam existindo nos dados mas não aparecem
   * mais na tela).
   */
  private reiniciarPrecoForm(): void {
    this.precoForm = {
      precoFabricante: '0.00',
      percentualCusto: '0.00',
      totalCusto: '0.00',
      percentualLucro: '0.00',
      precoVenda: '0.00',
      valorCore: '0.00',
      fornecedor: '',
    };
    this.listaFornecedoresPreco = [];
    this.fornecedorDropdownAberto = false;
    this.sincronizarPrecoComMargens();
    this._exibirAvisoSemPrecoTemporario();
  }

  /** Copia as margens (campos ocultos) para Custo (%) / Lucro (%) e recalcula. */
  private sincronizarPrecoComMargens(): void {
    const margCusto = this.getCampoValor('GPL_MARGEM_CUSTO').replace('%', '').replace(',', '.').trim() || '0.00';
    const margLucro = this.getCampoValor('GPL_MARGEM_LUCRO').replace('%', '').replace(',', '.').trim() || '0.00';
    this.precoForm.percentualCusto = margCusto;
    this.precoForm.percentualLucro = margLucro;
    this.calcularPreco();
  }

  /** Alterna a seleção "Todos" no modal. */
  toggleTodosOpcoesCopia(marcado: boolean): void {
    this.opcoesCopia.update((lista) =>
      lista.map((o) => ({ ...o, selecionada: marcado }))
    );
  }

  /** Verifica se todas as opções estão selecionadas (para o checkbox "Todos"). */
  todasOpcoesSelecionadas(): boolean {
    return this.opcoesCopia().every((o) => o.selecionada);
  }

  /** Alterna individualmente uma opção de cópia. */
  toggleOpcaoCopia(chave: string, marcado: boolean): void {
    this.opcoesCopia.update((lista) =>
      lista.map((o) => o.chave === chave ? { ...o, selecionada: marcado } : o)
    );
  }

  /** Cancela o modal "Copiar Também" sem salvar. */
  cancelarCopiaTambem(): void {
    this.copiaTambemModalAberta.set(false);
    this._dadosPendentesParaSalvar = null;
  }

  /** Confirma o modal: grava o produto e depois copia as tabelas selecionadas. */
  confirmarSalvar(): void {
    const dados = this._dadosPendentesParaSalvar;
    if (!dados) return;

    this.copiaTambemModalAberta.set(false);
    this.loading.set(true);
    this.loadingMsg.set('Gravando novo produto no Sankhya...');

    const codOrigemParaImpostos = String(this.produtoOrigem?.codprod || this.produtoOrigem?.codigo || '');

    // Os impostos já foram lidos durante selecionarModelo() e estão em impostosDoModelo.
    // São passados para duplicarProduto() para serem incluídos no INSERT inicial —
    // evitando um UPDATE separado que pode ser sobrescrito por triggers do Sankhya.
    this.produtoService.duplicarProdutoComAerosys(dados, this.impostosDoModelo).subscribe({
      next: (res) => {
        if (!res.novoCodProd) {
          this.loading.set(false);
          this.abrirAlerta(res.erro || 'Não foi possível confirmar a criação do produto. Verifique no Sankhya.', 'aviso');
          return;
        }

        const novoCod = res.novoCodProd;
        this.novoCodProd.set(novoCod);
        const codOrigem = codOrigemParaImpostos;

        // Resultado dos impostos — sempre incluídos no INSERT inicial
        const impostosQtd = Object.keys(this.impostosDoModelo).length;
        const resultadoImpostos: ResultadoCopiaTabela = {
          chave: 'impostos',
          label: 'Impostos / Campos fiscais (TGFPRO)',
          ok: true,
          qtd: impostosQtd
        };

        const opcoesSelecionadas = this.opcoesCopia().filter((o) => o.selecionada);

        if (!opcoesSelecionadas.length || !codOrigem) {
          // Nenhuma cópia adicional solicitada — mostra só resultado de impostos
          this.resultadosCopia.set([resultadoImpostos]);
          this.resultadosCopiaModalAberta.set(true);
          this._salvarCotacaoPreco(novoCod).finally(() =>
            this.salvarImagemPendente(novoCod).finally(() =>
              this._salvarAlternativosCadastro(novoCod).finally(async () => {
                await this.aguardarAerosys(novoCod);
                this.concluirCadastro();
              })
            )
          );
          return;
        }

        this.loadingMsg.set('Copiando informações relacionadas...');

        const copia$ = opcoesSelecionadas.map((o) =>
          this.executarCopiaOpcao(o.chave, codOrigem, novoCod)
        );

        forkJoin(copia$).subscribe({
          next: (resultados: ResultadoCopiaTabela[]) => {
            // Impostos sempre como primeira linha do resultado
            this.resultadosCopia.set([resultadoImpostos, ...resultados]);
            this.resultadosCopiaModalAberta.set(true);
            this._salvarCotacaoPreco(novoCod).finally(() =>
              this.salvarImagemPendente(novoCod).finally(() =>
                this._salvarAlternativosCadastro(novoCod).finally(async () => {
                  await this.aguardarAerosys(novoCod);
                  this.concluirCadastro();
                })
              )
            );
          },
          error: () => {
            this._salvarCotacaoPreco(novoCod).finally(() =>
              this.salvarImagemPendente(novoCod).finally(() =>
                this._salvarAlternativosCadastro(novoCod).finally(async () => {
                  await this.aguardarAerosys(novoCod);
                  this.concluirCadastro();
                })
              )
            );
          }
        });
      },
      error: (err) => {
        this.loading.set(false);
        this.abrirAlerta('Erro ao duplicar produto: ' + err.message, 'erro');
      }
    });
  }

  /** Despacha para o método de cópia correto com base na chave da opção. */
  private executarCopiaOpcao(chave: string, codprodOrigem: string, novoCodprod: string) {
    switch (chave) {
      case 'impostosEmpresa': return this.produtoService.copiarImpostosEmpresa(codprodOrigem, novoCodprod);
      case 'unidadesAlt':     return this.produtoService.copiarUnidadesAlternativas(codprodOrigem, novoCodprod);
      case 'produtosAlt':     return this.produtoService.copiarProdutosAlternativos(codprodOrigem, novoCodprod);
      case 'produtosEq':      return this.produtoService.copiarProdutosEquivalentes(codprodOrigem, novoCodprod);
      case 'produtosSug':     return this.produtoService.copiarProdutosSugeridos(codprodOrigem, novoCodprod);
      default:
        return of({ chave, label: chave, ok: false, qtd: 0, erro: 'Opção desconhecida' } as ResultadoCopiaTabela);
    }
  }

  /** Fim do cadastro (produto e Aerosys concluidos). Se veio da Lista, avisa e volta pra ela. */
  private concluirCadastro(): void {
    this.loading.set(false);
    this.etapa.set('sucesso');
    this.carregarImagem();
    if (this.retornoLista) {
      this.retornarAposAlerta = true;
      // Se o modal "Resultado - Copiar Tambem" ainda estiver aberto, o aviso vem depois do OK dele.
      if (!this.resultadosCopiaModalAberta()) {
        this.abrirAlerta('Produto cadastrado com sucesso!', 'sucesso');
      }
    }
  }

  fecharResultadosCopia(): void {
    this.resultadosCopiaModalAberta.set(false);
    if (this.retornarAposAlerta && this.etapa() === 'sucesso') {
      this.abrirAlerta('Produto cadastrado com sucesso!', 'sucesso');
    }
  }

  getCampoValor(field: string): string {
    return this.campos().find((c) => c.field === field)?.valor?.trim() || '';
  }

  // ── Precificação ──

  voltarParaForm(): void {
    this.etapa.set('form');
    this._exibirAvisoInfoTemporario();
  }

  confirmarSalvarComPreco(): void {
    const preco = this.precoToNumber(this.precoForm.precoFabricante);

    // Preço informado mas sem fornecedor → exige
    if (preco > 0 && !this.precoForm.fornecedor.trim()) {
      this.abrirAlerta('Informe o fornecedor (Cotação Realizada Em).', 'aviso');
      return;
    }

    this.confirmarSalvar();
  }

  /** Salva a cotação de preço após criar o produto. Chamado dentro de confirmarSalvar(). */
  /** Acompanha (com percentual no load) a gravacao em segundo plano no Aerosys ate finalizar. */
  private async aguardarAerosys(novoCod: string): Promise<void> {
    const inicio = Date.now();
    this.loading.set(true);
    this.loadingMsg.set('Finalizando cadastro no Aerosys... 0%');
    while (Date.now() - inicio < 180000) {
      try {
        const r = await firstValueFrom(this.produtoService.progressoAerosys(novoCod));
        this.loadingMsg.set(`Finalizando cadastro no Aerosys... ${r.finalizado ? 100 : r.percentual}%`);
        if (r.finalizado) return;
      } catch {
        return; // sem progresso disponivel: nao prende o usuario
      }
      await new Promise(res => setTimeout(res, 700));
    }
  }

  private async _salvarCotacaoPreco(novoCodProd: string): Promise<void> {
    const p = this.precoForm;
    const preco = this.precoToNumber(p.precoFabricante);
    if (preco === 0) return; // sem preço informado, não salva cotação

    // Sankhya recebe SOMENTE a observação escrita à mão; a linha de cotação
    // ("<fornecedor>   <data>   U$ <preço>") é montada pelo backend apenas no Aerosys.
    const campoObs = this.campos().find((c) => c.field === 'AD_OBSINT');
    if (campoObs) {
      campoObs.valor = removerLinhasCotacao(campoObs.valor);
      this.campos.set([...this.campos()]);
    }

    const payloadEdicao = {
      CODPROD: novoCodProd,
      FORNEC: p.fornecedor || '',
      PRECO: preco,
      VARIACAO: 0,
      CORE: this.getCampoValor('AD_CONTROLACORE') === 'S' ? this.precoToNumber(p.valorCore) : 0,
      LUCRO: this.precoToNumber(p.percentualLucro),
      CUSTO: this.precoToNumber(p.percentualCusto),
      PRECOVENDA: this.precoToNumber(p.precoVenda),
      // Total Custo $ (calculado em calcularPreco()) -- precisa ir junto pro
      // backend gravar EST_CUSTO no Aerosys (nao tinha antes, 2026-09-16).
      TOTALCUSTO: this.precoToNumber(p.totalCusto),
      REFFORN: this.getCampoValor('REFFORN'),
      DESCRPROD: this.getCampoValor('DESCRPROD'),
      CODVOL: this.getCampoValor('CODVOL'),
      TEMSERIE: this.getCampoValor('TIPCONTEST') || 'N',
      TEMCORE: this.getCampoValor('AD_CONTROLACORE') === 'S' ? 'S' : 'N',
      MARCA: this.getCampoValor('MARCA'),
      CONDICAO: this.getCampoValor('AD_CONDICAO') || '',
      OBSTECNICA: this.getCampoValor('AD_OBSTEC'),
      OBSINTERNA: this.getCampoValor('AD_OBSINT'),
      // Label (Nome Estrangeiro) do Aerosys -- sincronizarEdicao() do backend
      // mapeia isso pra APE_LABEL. Faltava aqui (2026-09-16): os campos dessa
      // 2ª etapa (Und/Descrição Técnica/Observações/Label) só iam pro Sankhya
      // via salvarCotacaoProdutoEdicao, nunca eram espelhados no Aerosys.
      // Label (USA) agora vem só de GPL_LABEL (DESCRESTRAG nativo não é mais usado).
      GPL_LABEL: this.getCampoValor('GPL_LABEL'),
      // Só para o Aerosys (montagem da linha de cotação na observação).
      ATUALIZAR_DATA_PRECO: true,
      MOEDA_SIMBOLO: this.moedaPreco(),
    };

    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.salvarCotacaoProdutoEdicao(payloadEdicao)
      );
      if (res && res.sucesso === false) {
        console.warn('Cotação retornou erro:', res.mensagem || res);
        this.abrirAlerta('Produto salvo, mas houve erro ao salvar cotação: ' + (res.mensagem || 'Erro desconhecido'), 'aviso');
      } else {
        // Best-effort: espelha Und/Descrição Técnica/Observações/Label no
        // Aerosys. Não bloqueia nem reverte o fluxo se falhar (mesmo padrão
        // de gpl-edicao-produtos.component.ts#sincronizarEdicaoComAerosys).
        try {
          await firstValueFrom(this.produtoService.sincronizarEdicaoProdutoAerosys(payloadEdicao));
        } catch (e) {
          console.warn('Falha ao sincronizar 2ª etapa do produto com o Aerosys:', e);
        }
      }
    } catch (e: any) {
      console.error('Erro ao salvar cotação:', e);
      this.abrirAlerta('Produto salvo, mas houve erro ao salvar cotação de preço.', 'aviso');
    }
  }

  calcularPreco(): void {
    const preco   = this.precoToNumber(this.precoForm.precoFabricante);
    const custo   = this.precoToNumber(this.precoForm.percentualCusto);
    const lucro   = this.precoToNumber(this.precoForm.percentualLucro);
    const total   = Math.ceil(preco * (1 + custo / 100) * 100) / 100;
    const venda   = Math.ceil(total * (1 + lucro / 100) * 100) / 100;
    this.precoForm.precoFabricante = this.precoFormatar(preco);
    this.precoForm.percentualCusto = this.precoFormatar(custo);
    this.precoForm.percentualLucro = this.precoFormatar(lucro);
    this.precoForm.totalCusto      = this.precoFormatar(total);
    this.precoForm.precoVenda      = this.precoFormatar(venda);
  }

  removerVirgula(campo: keyof typeof this.precoForm): void {
    (this.precoForm as any)[campo] = String((this.precoForm as any)[campo]).replace(/,/g, '');
  }

  formatarCampoPreco(campo: keyof typeof this.precoForm): void {
    (this.precoForm as any)[campo] = this.precoFormatar(this.precoToNumber((this.precoForm as any)[campo]));
  }

  precoToNumber(valor: any): number {
    if (!valor && valor !== 0) return 0;
    let s = String(valor).trim();
    const pi = s.lastIndexOf('.'), vi = s.lastIndexOf(',');
    if (pi !== -1 && vi !== -1) {
      s = vi > pi ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
    } else if (vi !== -1) {
      s = s.replace(',', '.');
    }
    return parseFloat(s) || 0;
  }

  precoFormatar(valor: any): string {
    return Number(valor || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // ── Máscara de Peso ──────────────────────────────────────────────
  pesoFormatar(valor: any): string {
    const n = this.precoToNumber(valor);
    // Usa ponto como decimal (compatível com Sankhya) com 3 casas
    return n.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
  }

  onPesoFocus(c: { valor: string }): void {
    c.valor = String(this.precoToNumber(c.valor) || '');
  }

  onPesoBlur(c: { valor: string }): void {
    c.valor = this.pesoFormatar(c.valor);
  }

  async buscarFornecedoresPreco(valor: string): Promise<void> {
    this.fornecedorBuscaSeq++;
    const seq = this.fornecedorBuscaSeq;
    if (!valor || valor.trim().length < 2) {
      this.listaFornecedoresPreco = [];
      this.fornecedorDropdownAberto = false;
      return;
    }
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarFornecedoresEdicao({ DESCRICAO: valor }) as any
      );
      if (seq !== this.fornecedorBuscaSeq) return;
      this.listaFornecedoresPreco = res?.responseBody?.lista || res?.lista || [];
      this.fornecedorDropdownAberto = this.listaFornecedoresPreco.length > 0;
    } catch { this.listaFornecedoresPreco = []; }
  }

  selecionarFornecedorPreco(f: { descricao: string }): void {
    this.precoForm.fornecedor = f.descricao;
    this.listaFornecedoresPreco = [];
    this.fornecedorDropdownAberto = false;
    this.fornecedorBuscaSeq++;
  }

  /** CNPJ/CPF (só dígitos) formatado para exibir na lista de fornecedores. */
  fmtDocFornecedor(doc: string | null | undefined): string {
      const d = String(doc ?? '').replace(/\D/g, '');
      if (d.length === 14) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
      if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
      return d;
  }

  abrirFornecedoresPreco(): void {
    if ((this.precoForm.fornecedor || '').trim().length >= 2 && this.listaFornecedoresPreco.length) {
      this.fornecedorDropdownAberto = true;
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(e: KeyboardEvent): void {
    // Navegação de imagens no modal (setas)
    if (this.mostrarModalSelecao && this.imagensPendentes.length > 1) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.indexVisualizandoPendente = (this.indexVisualizandoPendente + 1) % this.imagensPendentes.length;
        return;
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.indexVisualizandoPendente = (this.indexVisualizandoPendente - 1 + this.imagensPendentes.length) % this.imagensPendentes.length;
        return;
      }
    }

    // Enter para navegar entre campos do formulário
    if (e.key === 'Enter') {
      this._navegarEnter(e);
    }
  }

  private _navegarEnter(e: KeyboardEvent): void {
    const active = document.activeElement as HTMLElement;
    if (!active) return;

    // Não interceptar Enter em botões (deixa clicar normalmente)
    if (active.tagName === 'BUTTON') return;
    // Não interceptar enquanto modal de imagem estiver aberto
    if (this.mostrarModalSelecao) return;

    // Seleciona o container da etapa atual
    const etapaAtual = this.etapa();
    const containerSel =
      etapaAtual === 'preco' ? '.preco-card' :
      etapaAtual === 'form'  ? '.card'       : null;
    if (!containerSel) return;

    const container = document.querySelector(containerSel);
    if (!container) return;

    // Todos os elementos focáveis visíveis dentro do container
    const focusable = Array.from(container.querySelectorAll<HTMLElement>(
      'input:not([type="file"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])'
    )).filter(el => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length));

    const idx = focusable.indexOf(active);
    if (idx === -1) return;

    e.preventDefault();

    // Se for checkbox (toggle), dispara change para o Angular processar o toggle
    if (active.tagName === 'INPUT' && (active as HTMLInputElement).type === 'checkbox') {
      (active as HTMLInputElement).checked = !(active as HTMLInputElement).checked;
      active.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const next = focusable[idx + 1];
    if (next) {
      next.focus();
      // Se for select, abre o dropdown
      if (next.tagName === 'SELECT') {
        (next as HTMLSelectElement).dispatchEvent(new MouseEvent('mousedown'));
      }
    }
  }

  voltarParaOrigem(): void {
    if (!this.origemRetorno) return;
    this.voltarOrigem.emit({ origem: this.origemRetorno, codprod: this.codprodFonteClone });
  }

  get nomeOrigemRetorno(): string {
    return this.origemRetorno === 'lista-produtos' ? 'Lista de Produtos' : 'Edição';
  }

  novaDuplicacao(): void {
    this.etapa.set('lista');
    this.produtoOrigem = null;
    this.campos.set([]);
    this.novoCodProd.set(null);
    this.buscarModelos();
  }

  /** Clique no card "Produto Cadastrado com Sucesso!" -- pede pro Gateway
   * navegar direto pra tela de Edição de Produtos já aberta nesse item. */
  abrirEdicaoDoProdutoCriado(): void {
    const cod = this.novoCodProd();
    if (cod) this.irParaEdicao.emit(cod);
  }

  abrirAlerta(texto: string, tipo: 'sucesso' | 'erro' | 'aviso' = 'aviso'): void {
    this.alertaTexto.set(texto);
    this.alertaTipo.set(tipo);
    this.alertaModal.set(true);
  }

  fecharAlerta(): void {
    this.alertaModal.set(false);
    if (this.retornarAposAlerta && this.alertaTipo() === 'sucesso') {
      this.retornarAposAlerta = false;
      this.voltarOrigem.emit({ origem: 'lista-produtos', codprod: '' });
    }
  }

  /**
   * Destaca (igual ao Sankhya) as ocorrências do termo pesquisado dentro do
   * texto exibido (ex.: descrição do produto modelo), envolvendo-as em
   * <mark class="busca-highlight">.
   */
  destacarTermo(texto: string | null | undefined): SafeHtml {
    const valor = texto || '';
    const escapado = this.escapeHtml(valor);
    const termo = this.termoBusca.trim();
    if (!termo) {
      return this.sanitizer.bypassSecurityTrustHtml(escapado);
    }

    let termoRegexStr = this.escapeRegExp(this.escapeHtml(termo));
    const termoAlfanum = termo.replace(/[^a-zA-Z0-9]/g, '');
    
    // Se o termo de busca for composto apenas por letras, números, espaços ou traços,
    // criamos uma regex flexível que ignora a presença (ou ausência) de traços/espaços.
    if (termoAlfanum.length > 0 && termo.replace(/[-_\s]/g, '') === termoAlfanum) {
      termoRegexStr = termoAlfanum.split('').join('[-_\\s]*');
    }

    const regex = new RegExp(`(${termoRegexStr})`, 'gi');
    const destacado = escapado.replace(regex, '<mark class="busca-highlight">$1</mark>');
    return this.sanitizer.bypassSecurityTrustHtml(destacado);
  }

  private escapeHtml(texto: string): string {
    return texto
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  private escapeRegExp(texto: string): string {
    return texto.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // ── Imagens ──────────────────────────────────────────────────────────────

  /** Clonar: copia as imagens do produto de origem como imagens pendentes (gravadas ao salvar o novo produto). */
  private async clonarImagensDoProduto(codprod: number): Promise<void> {
    try {
      const response: any = await this.respostaGateway(
        this.sankhyaGateway.buscarImgProdutoEdicao({ CODPROD: codprod })
      );
      const bases: string[] = [];
      const principal: string = response?.principal || '';
      if (principal) bases.push(principal);
      for (const img of (response?.lista || [])) {
        const b = img?.imagem;
        if (b && !bases.includes(b)) bases.push(b);
      }
      const lista = bases.slice(0, 6).map((base64) => ({ src: `data:image/jpeg;base64,${base64}`, base64 }));
      if (!lista.length) return;
      this.imagensPendentes = lista;
      this.indexPadrao = 0;
      this.indexVisualizandoPendente = 0;
      this.imagemPrincipal = { src: lista[0].src, imgId: 0 };
      this.listaImagens = lista.map((i) => ({ src: i.src, imgId: 0 }));
    } catch {
      // Sem imagem na origem: segue sem imagem.
    }
  }

  /** Carrega a imagem do produto MODELO para exibir durante o preenchimento do form. */
  async carregarImagemModelo(codprod: number): Promise<void> {
    try {
      const response: any = await this.respostaGateway(
        this.sankhyaGateway.buscarImgProdutoEdicao({ CODPROD: String(codprod) })
      );
      this.imagemPrincipal = response?.principal
        ? { src: `data:image/jpeg;base64,${response.principal}`, imgId: 0 }
        : { src: this.gerarPlaceholder(this.produtoOrigem?.descricao || 'PRO'), imgId: 0 };
      this.listaMiniaturas = (response?.lista || []).map((img: any) => ({
        src: `data:image/jpeg;base64,${img.imagem}`,
        imgId: img.imgId
      }));
    } catch {
      this.imagemPrincipal = { src: this.gerarPlaceholder(this.produtoOrigem?.descricao || 'PRO'), imgId: 0 };
      this.listaMiniaturas = [];
    }
  }

  async carregarImagem(): Promise<void> {
    const cod = this.novoCodProd();
    if (!cod) return;

    try {
      const response: any = await this.respostaGateway(
        this.sankhyaGateway.buscarImgProdutoEdicao({ CODPROD: cod })
      );

      this.imagemPrincipal = response?.principal
        ? { src: `data:image/jpeg;base64,${response.principal}`, imgId: 0 }
        : { src: this.gerarPlaceholder(this.produtoOrigem?.descricao || 'PRO'), imgId: 0 };

      this.listaMiniaturas = (response?.lista || []).map((img: any) => ({
        src: `data:image/jpeg;base64,${img.imagem}`,
        imgId: img.imgId
      }));
    } catch {
      this.imagemPrincipal = { src: this.gerarPlaceholder(this.produtoOrigem?.descricao || 'PRO'), imgId: 0 };
      this.listaMiniaturas = [];
    }
  }

  abrirGaleria(imgId?: number): void {
    this.listaImagens = [];
    if (this.imagemPrincipal && !this.ehPlaceholder(this.imagemPrincipal)) this.listaImagens.push(this.imagemPrincipal);
    this.listaMiniaturas.forEach((img) => { if (img.imgId !== 0) this.listaImagens.push(img); });
    if (!this.listaImagens.length) return;
    const index = this.listaImagens.findIndex((img) => img.imgId === imgId);
    this.indexImagem = index >= 0 ? index : 0;
    this.imagemAtual = this.listaImagens[this.indexImagem];
    this.modalGaleria = true;
  }

  fecharGaleria(): void { this.modalGaleria = false; }

  proximaImagem(): void {
    if (!this.listaImagens.length) return;
    this.indexImagem = (this.indexImagem + 1) % this.listaImagens.length;
    this.imagemAtual = this.listaImagens[this.indexImagem];
  }

  imagemAnterior(): void {
    if (!this.listaImagens.length) return;
    this.indexImagem = this.indexImagem <= 0 ? this.listaImagens.length - 1 : this.indexImagem - 1;
    this.imagemAtual = this.listaImagens[this.indexImagem];
  }

  irParaImagem(index: number): void {
    if (index < 0 || index >= this.listaImagens.length) return;
    this.indexImagem = index;
    this.imagemAtual = this.listaImagens[index];
  }

  async onImagemSelecionada(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files ?? []);
    if (!files.length) return;
    try {
      const novas = await Promise.all(
        files.map(async (file) => {
          const base64 = await this.processarImagem(file);
          return { src: `data:image/jpeg;base64,${base64}`, base64 };
        })
      );
      const anteriorLen = this.imagensPendentes.length;
      const limite = 6;
      const vagas = limite - anteriorLen;
      if (vagas <= 0) {
        this.abrirAlerta('Limite de 6 imagens atingido.', 'aviso');
        return;
      }
      const novasFiltradas = novas.slice(0, vagas);
      if (novas.length > vagas) {
        this.abrirAlerta(`Apenas ${vagas} imagem(ns) adicionada(s). Limite de 6 imagens atingido.`, 'aviso');
      }
      this.imagensPendentes = [...this.imagensPendentes, ...novasFiltradas];
      // Auto-seleciona padrão se só há uma imagem no total
      if (this.imagensPendentes.length === 1) {
        this.indexPadrao = 0;
      }
      // Posiciona visualização na primeira das novas imagens adicionadas
      this.indexVisualizandoPendente = anteriorLen > 0 ? anteriorLen : 0;
      this.mostrarModalSelecao = true;
    } catch {
      this.abrirAlerta('Erro ao processar imagem', 'erro');
    }
    input.value = '';
  }

  removerImagemPendente(index: number, event: Event): void {
    event.stopPropagation();
    this.imagensPendentes.splice(index, 1);
    if (this.indexPadrao === index) {
      this.indexPadrao = this.imagensPendentes.length === 1 ? 0 : -1;
    } else if (this.indexPadrao > index) {
      this.indexPadrao--;
    }
    // Ajusta índice de visualização após remoção
    if (this.indexVisualizandoPendente >= this.imagensPendentes.length) {
      this.indexVisualizandoPendente = Math.max(0, this.imagensPendentes.length - 1);
    }
    if (!this.imagensPendentes.length) {
      this.mostrarModalSelecao = false;
    }
  }

  confirmarSelecaoImagens(): void {
    if (this.indexPadrao < 0 || this.indexPadrao >= this.imagensPendentes.length) return;
    const padrao = this.imagensPendentes[this.indexPadrao];
    this.imagemPrincipal = { src: padrao.src, imgId: 0 };
    this.listaImagens = this.imagensPendentes.map((img) => ({ src: img.src, imgId: 0 }));
    this.mostrarModalSelecao = false;
  }

  cancelarSelecaoImagens(): void {
    this.imagensPendentes = [];
    this.indexPadrao = -1;
    this.indexVisualizandoPendente = 0;
    this.mostrarModalSelecao = false;
    this.imagemPrincipal = null;
    this.listaImagens = [];
  }

  abrirSelecao(): void {
    this.mostrarModalSelecao = true;
  }

  /**
   * Salva a imagem escolhida no formulário (imagemTemp) para o produto recém-criado.
   * Chamado logo após duplicarProduto() ter sucesso. Falha silenciosa.
   */
  private async salvarImagemPendente(novoCod: string): Promise<void> {
    if (!this.imagensPendentes.length || !novoCod) return;
    try {
      for (let i = 0; i < this.imagensPendentes.length; i++) {
        const ehPadrao = i === this.indexPadrao;
        await this.respostaGateway(
          this.sankhyaGateway.salvarImgProdutoEdicao({
            CODPROD: novoCod,
            IMAGEM: this.imagensPendentes[i].base64,
            PADRAO: ehPadrao,
            IMGID: 0,
          })
        );
        // Espelha a imagem PADRÃO no Aerosys (servidor de documentos,
        // cadastros/pecas/ + APE_IMAGEM) -- best-effort, só a padrão porque
        // APE_IMAGEM guarda um único nome de arquivo, não uma galeria.
        if (ehPadrao) {
          this.produtoService.salvarImagemProdutoAerosys({
            CODPROD: novoCod,
            DESCRPROD: this.getCampoValor('DESCRPROD'),
            REFFORN: this.getCampoValor('REFFORN'),
            IMAGEM: this.imagensPendentes[i].base64,
          }).subscribe({
            error: (e) => console.warn('Falha ao sincronizar imagem do produto com o Aerosys:', e)
          });
        }
      }
    } catch {
      // falha não bloqueia o fluxo principal
    } finally {
      this.imagensPendentes = [];
      this.indexPadrao = -1;
    }
  }

  async deletarImgProduto(img: { src: string; imgId: number }): Promise<void> {
    const cod = this.novoCodProd();
    if (!cod || !img) return;
    try {
      const response: any = await this.respostaGateway(
        this.sankhyaGateway.deletarImgProdutoEdicao({ CODPROD: cod, IMGID: img.imgId || 0 })
      );
      if (response?.mensagem) {
        this.abrirAlerta('Imagem removida com sucesso!', 'sucesso');
        this.fecharGaleria();
        await this.carregarImagem();
      }
    } catch {
      this.abrirAlerta('Erro ao excluir imagem', 'erro');
    }
  }

  async definirComoPadrao(img: { src: string; imgId: number } | null, troca: boolean): Promise<void> {
    const cod = this.novoCodProd();
    if (!cod || !img?.src || this.ehPlaceholder(img)) return;
    try {
      const base64 = img.src.split(',')[1];
      const response: any = await this.respostaGateway(
        this.sankhyaGateway.salvarImgProdutoEdicao({ CODPROD: cod, IMAGEM: base64, PADRAO: true, TROCA: troca, IMGID: img.imgId || 0 })
      );
      if (response?.mensagem) {
        this.fecharGaleria();
        await this.carregarImagem();
      }
    } catch {
      this.abrirAlerta('Erro ao definir imagem padrão', 'erro');
    }
  }

  private processarImagem(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const img = new Image();
        img.onload = () => {
          const maxDim = 800;
          const qualidade = 0.7;
          let { width, height } = img;
          if (width > height && width > maxDim) { height *= maxDim / width; width = maxDim; }
          else if (height > maxDim) { width *= maxDim / height; height = maxDim; }
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) { reject('Canvas inválido'); return; }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL('image/jpeg', qualidade).split(',')[1]);
        };
        img.onerror = reject;
        img.src = event.target.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  private async respostaGateway<T = any>(observable: any): Promise<T> {
    const value: any = await firstValueFrom(observable);
    if (!value) throw new Error('Resposta vazia do gateway.');
    if (value.status && value.status !== '1') throw new Error(value.statusMessage || 'Erro no gateway.');
    return (value.responseBody || value) as T;
  }

  // ───────────────────────────────────────────────────────────────────────────

  /** Imagens-padrão geradas (letras) NÃO são imagens do produto: nunca podem ser salvas. */

  private placeholdersGerados = new Set<string>();

  ehPlaceholder(img: { src?: string; imgId?: number } | null): boolean {

    return !!img?.src && this.placeholdersGerados.has(img.src);

  }


  gerarPlaceholder(texto: string): string {
    const base = (texto || 'PRO').trim();
    const letters = (base.substring(0, 3) || 'PRO').toUpperCase();
    const colors = ['#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#e67e22', '#e74c3c', '#34495e'];
    const bgColor = colors[letters.charCodeAt(0) % colors.length];

    const size = 200;
    const radius = 30;

    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.beginPath();
      ctx.moveTo(radius, 0);
      ctx.lineTo(size - radius, 0);
      ctx.quadraticCurveTo(size, 0, size, radius);
      ctx.lineTo(size, size - radius);
      ctx.quadraticCurveTo(size, size, size - radius, size);
      ctx.lineTo(radius, size);
      ctx.quadraticCurveTo(0, size, 0, size - radius);
      ctx.lineTo(0, radius);
      ctx.quadraticCurveTo(0, 0, radius, 0);
      ctx.closePath();

      ctx.fillStyle = bgColor;
      ctx.fill();

      ctx.fillStyle = '#ffffff';
      ctx.font = 'bold 70px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(letters, size / 2, size / 2);
    }

    const url = canvas.toDataURL('image/png');
    this.placeholdersGerados.add(url);
    return url;
  }

  // ── Produtos Alternativos (cadastro) ─────────────────────────────────────

  async buscarProdutosAlternativosModal(): Promise<void> {
    this.carregandoProdutosAlternativos = true;
    try {
      const response: any = await firstValueFrom(
        this.sankhyaGateway.pesquisarProdutosAlternativosNativos(
          '0',
          this.filtroProdutoAlternativo || '',
          this.marcaProdutoAlternativo || ''
        )
      );
      this.produtosAlternativosBusca = Array.isArray(response) ? response : [];
    } catch (e) {
      this.produtosAlternativosBusca = [];
    } finally {
      this.carregandoProdutosAlternativos = false;
    }
  }

  aoDigitarProdutoAlternativoCadastro(): void {
    clearTimeout(this.buscaAlternativosTimer);
    this.buscaAlternativosTimer = setTimeout(() => this.buscarProdutosAlternativosModal(), 300);
  }

  alternarProdutoAlternativoCadastro(prod: any): void {
    const idx = this.produtosAlternativosSelecionados.findIndex(
      (p) => String(p.codprod) === String(prod.codprod)
    );
    if (idx >= 0) {
      this.produtosAlternativosSelecionados = this.produtosAlternativosSelecionados.filter((_, i) => i !== idx);
    } else {
      this.produtosAlternativosSelecionados = [...this.produtosAlternativosSelecionados, prod];
    }
  }

  produtoAlternativoSelecionadoCadastro(prod: any): boolean {
    return this.produtosAlternativosSelecionados.some((p) => String(p.codprod) === String(prod.codprod));
  }

  abrirModalFabricantesCadastro(): void {
    // Abre o modal de marcas no contexto do alternativo (filtro da busca, nao o Marca do produto)
    this.marcaModalDestino = 'alternativo';
    this.filtroMarca.set('');
    this.marcaModalAberta.set(true);
    this.focarInputModalBusca();
  }

  /** Chamado após criar o produto com sucesso, para salvar os alternativos selecionados. */
  private async _salvarAlternativosCadastro(novoCodProd: string): Promise<void> {
    if (!this.produtosAlternativosSelecionados.length) return;
    try {
      const response: any = await firstValueFrom(
        this.sankhyaGateway.salvarProdutosAlternativosNativos(novoCodProd, this.produtosAlternativosSelecionados)
      );
      if (response?.sucesso) {
        console.log(`[Cadastro] ${this.produtosAlternativosSelecionados.length} produto(s) alternativo(s) vinculado(s) com sucesso.`);
      } else {
        console.warn('[Cadastro] Não foi possível vincular produtos alternativos:', response?.mensagem);
      }
    } catch (e) {
      console.warn('[Cadastro] Erro ao salvar produtos alternativos:', e);
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
}
